const fr = {
  'common.loading': 'Chargement…',
  'common.save': 'Enregistrer',
  'common.saving': 'Enregistrement…',
  'common.cancel': 'Annuler',
  'common.delete': 'Supprimer',
  'common.search': 'Rechercher',
  'common.sortBy': 'Trier par',
  'common.never': 'Jamais',
  'common.justNow': 'À l’instant',
  'common.accessDenied': 'Accès refusé',
  'common.backToLogin': 'Retour à la connexion',
  'common.markAsRead': 'Marquer comme lu',
  'common.user': 'Utilisateur',
  'shell.supportDesk': 'Centre de support',
  'shell.searchPlaceholder': 'Rechercher des tickets, contacts, articles…',
  'shell.newTicket': 'Nouveau ticket',
  'shell.notifications': 'Notifications',
  'shell.notificationPreferences': 'Préférences de notifications',
  'shell.settings': 'Paramètres',
  'shell.signOut': 'Se déconnecter',
  'shell.expandNavigation': 'Développer la navigation',
  'shell.collapseNavigation': 'Réduire la navigation',
  'shell.adminNavigation': 'Navigation d’administration',
  'shell.caughtUp': 'Vous êtes à jour',
  'shell.viewAllNotifications': 'Voir toutes les notifications',
  'nav.dashboard': 'Tableau de bord',
  'nav.tickets': 'Tickets',
  'nav.contacts': 'Contacts',
  'nav.companies': 'Entreprises',
  'nav.reports': 'Rapports',
  'nav.settings': 'Paramètres',
  'nav.agents': 'Agents',
  'nav.groups': 'Groupes',
  'nav.roles': 'Rôles',
  'nav.tags': 'Étiquettes',
  'nav.ticketFields': 'Champs du ticket',
  'nav.ticketForms': 'Formulaires de ticket',
  'nav.businessHours': 'Heures ouvrées',
  'nav.slaPolicies': 'Politiques SLA',
  'nav.automations': 'Automatisations',
  'nav.email': 'E-mail',
  'nav.notificationTemplates': 'Modèles de notification',
  'nav.apiKeys': 'Clés API',
  'nav.cannedResponses': 'Réponses enregistrées',
  'nav.knowledgeBase': 'Base de connaissances',
  'auth.signInTitle': 'Centre de support SDPL',
  'auth.signInSubtitle': 'Connectez-vous à votre compte',
  'auth.emailAddress': 'Adresse e-mail',
  'auth.password': 'Mot de passe',
  'auth.signingIn': 'Connexion…',
  'auth.signIn': 'Se connecter',
  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.twoFactor': 'Authentification à deux facteurs',
  'auth.verificationCode': 'Code de vérification',
  'auth.verify': 'Vérifier',
  'auth.backToLogin': 'Retour à la connexion',
  'agents.title': 'Agents',
  'agents.new': 'Nouvel agent',
  'agents.supportAgents': 'Agents de support',
  'agents.collaborators': 'Collaborateurs',
  'agents.deactivated': 'Désactivés',
  'agents.searchPlaceholder': 'Rechercher par nom ou e-mail',
  'agents.noSearchResults': 'Aucun agent ne correspond à cette recherche',
  'agents.noAgentsView': 'Aucun agent dans cette vue',
  'agents.edit': 'Modifier',
  'agents.deactivate': 'Désactiver',
  'agents.reactivate': 'Réactiver',
  'agents.saved': 'Agent enregistré.',
  'agents.firstName': 'Prénom',
  'agents.lastName': 'Nom',
  'agents.email': 'E-mail',
  'agents.phone': 'Téléphone',
  'agents.timezone': 'Fuseau horaire',
  'agents.selectTimezone': 'Sélectionner un fuseau horaire',
  'agents.language': 'Langue',
  'agents.selectLanguage': 'Sélectionner une langue',
  'agents.emailSignature': 'Signature e-mail',
  'agents.roleRequired': 'Rôle',
  'agents.selectRole': 'Sélectionner un rôle',
  'agents.status': 'Statut',
  'agents.groupsTitle': 'Groupes',
  'agents.manageGroups': 'Gérer les groupes',
  'agents.notInGroup': 'Pas encore dans un groupe',
  'dashboard.title': 'Tableau de bord',
  'dashboard.description': 'Charge actuelle du support et état du service.',
  'dashboard.allGroups': 'Tous les groupes accessibles',
  'dashboard.unresolved': 'Non résolus',
  'dashboard.overdue': 'En retard',
  'dashboard.dueToday': 'À traiter aujourd’hui',
  'dashboard.open': 'Ouverts',
  'dashboard.onHold': 'En attente',
  'dashboard.unassigned': 'Non attribués',
  'dashboard.trends': 'Tendances du jour',
  'dashboard.today': 'Aujourd’hui',
  'dashboard.yesterday': 'Hier',
  'notifications.title': 'Notifications',
  'notifications.description': 'Votre historique complet de notifications.',
  'notifications.markAllRead': 'Tout marquer comme lu',
  'notifications.filter': 'Filtre',
  'notifications.allTypes': 'Tous les types',
  'notifications.none': 'Aucune notification pour le moment',
  'notifications.assigned': 'Attribué',
  'notifications.reply': 'Réponse',
  'notifications.note': 'Note',
  'notifications.slaWarning': 'Alerte SLA',
  'notifications.slaBreach': 'Violation SLA',
  'notifications.slaEscalation': 'Escalade SLA',
  'notifications.mention': 'Mention',
  'preferences.title': 'Préférences de notifications',
  'preferences.description': 'Les notifications dans l’application restent activées. Choisissez celles qui doivent aussi envoyer un e-mail.',
  'preferences.emailDigest': 'Résumé par e-mail',
  'preferences.dailySummary': 'Recevoir un résumé quotidien plutôt qu’un e-mail pour chaque événement.',
  'preferences.digestOff': 'Désactivé — e-mail pour chaque événement',
  'preferences.digestDaily': 'Résumé quotidien',
  'preferences.emailNotifications': 'Notifications par e-mail',
  'activities.button': 'Activités récentes',
  'activities.title': 'Activités récentes',
  'activities.loadError': 'Impossible de charger les activités récentes.',
  'activities.systemActor': 'Système',
  'activities.noneTitle': 'Aucune activité récente pour le moment',
  'activities.noneDescription': 'Les mises à jour de tickets de vous et de votre groupe apparaîtront ici au fil du temps.',
  'tickets.title': 'Tickets',
  'tickets.description': 'Tous les tickets auxquels vous avez accès, filtrés et triés selon vos besoins.',
  'tickets.dueDateTabs': 'Échéance du ticket',
  'tickets.tabAll': 'Tous les tickets',
  'tickets.tabDueToday': "Échéance aujourd'hui",
  'tickets.tabOverdue': 'En retard',
  'tickets.tabDueTomorrow': 'Échéance demain',
  'tickets.searchPlaceholder': 'Rechercher des tickets…',
  'tickets.searchAria': 'Rechercher des tickets',
  'tickets.filters': 'Filtres',
  'tickets.filtersWithCount': 'Filtres ({count})',
  'tickets.sortAria': 'Trier les tickets par',
  'tickets.sortTrigger': 'Trier : {label}',
  'tickets.sortDateCreated': 'Date de création',
  'tickets.sortDateUpdated': 'Date de mise à jour',
  'tickets.sortPriority': 'Priorité',
  'tickets.sortStatus': 'Statut',
  'tickets.sortDueDate': "Date d'échéance",
  'tickets.sortAscending': 'Trier par ordre croissant',
  'tickets.sortDescending': 'Trier par ordre décroissant',
  'tickets.ascending': 'Croissant',
  'tickets.descending': 'Décroissant',
  'tickets.layoutAria': 'Disposition des lignes',
  'tickets.layoutTrigger': 'Disposition : {label}',
  'tickets.layoutCard': 'Carte',
  'tickets.layoutInbox': 'Boîte de réception',
  'tickets.layoutTable': 'Tableau',
  'tickets.export': 'Exporter',
  'tickets.exportSelected': 'Exporter la sélection',
  'tickets.selectedCount': '{count} sélectionné(s)',
  'tickets.assignAgent': 'Attribuer un agent',
  'tickets.closeAll': 'Tout fermer',
  'tickets.clearSelection': 'Effacer la sélection',
  'tickets.selectAgentPlaceholder': 'Sélectionner un agent...',
  'tickets.assignTo': 'Attribuer à',
  'tickets.assign': 'Attribuer',
  'tickets.loadFailed': 'Impossible de charger les tickets. Veuillez réessayer.',
  'tickets.bulkCloseFailed': 'Impossible de fermer les tickets sélectionnés. Veuillez réessayer.',
  'tickets.bulkAssignFailed': "Impossible d'attribuer les tickets sélectionnés. Veuillez réessayer.",
  'tickets.noFilterMatchTitle': 'Aucun ticket ne correspond à ces filtres',
  'tickets.noFilterMatchDescription': "Essayez de retirer un filtre, d'élargir la plage de dates ou de rechercher un autre terme.",
  'tickets.clearFilters': 'Effacer les filtres',
  'tickets.queueClearTitle': 'Cette file est vide',
  'tickets.queueClearDescription': "Les nouveaux tickets apparaîtront ici lorsqu'un client envoie un e-mail, utilise le portail ou qu'un agent en crée un.",
  'tickets.newTicket': 'Nouveau ticket',
  'tickets.selectAllAria': 'Sélectionner tous les tickets',
  'tickets.selectTicketAria': 'Sélectionner le ticket n° {number}',
  'tickets.columnContact': 'Contact',
  'tickets.columnSubject': 'Objet',
  'tickets.columnState': 'État',
  'tickets.columnGroup': 'Groupe',
  'tickets.columnAgent': 'Agent',
  'tickets.columnPriority': 'Priorité',
  'tickets.noGroup': 'Aucun groupe',
  'tickets.unassigned': 'Non attribué',
  'tickets.createdRelative': 'Créé {when}',
  'tickets.unassignedOnly': 'Non attribués uniquement',
  'tickets.unknownRequester': 'Demandeur inconnu',
  'tickets.overdueBy': 'En retard de {duration}',
  'tickets.dueIn': 'Échéance dans {duration}',
  'tickets.filtersDrawerTitle': 'Filtres',
  'tickets.filtersSearchPlaceholder': 'Rechercher des champs',
  'tickets.filtersSearchAria': 'Rechercher des champs de filtre',
  'tickets.filtersClearAll': 'Tout effacer',
  'tickets.filtersApply': 'Appliquer',
  'tickets.filterAgents': 'Agents',
  'tickets.filterAnyAgent': 'Tous les agents',
  'tickets.filterGroups': 'Groupes',
  'tickets.filterAnyGroup': 'Tous les groupes',
  'tickets.filterStatus': 'Statut',
  'tickets.filterAnyStatus': 'Tous les statuts',
  'tickets.filterPriority': 'Priorité',
  'tickets.filterAnyPriority': 'Toutes les priorités',
  'tickets.filterSource': 'Source',
  'tickets.filterAnySource': 'Toutes les sources',
  'tickets.filterTicketType': 'Type de ticket',
  'tickets.filterAnyType': 'Tous les types',
  'tickets.filterTags': 'Étiquettes',
  'tickets.filterAnyTag': 'Toutes les étiquettes',
  'tickets.filterCompanies': 'Entreprises',
  'tickets.filterAnyCompany': 'Toutes les entreprises',
  'tickets.filterCreated': 'Créé',
  'tickets.filterResolvedAt': 'Résolu le',
  'tickets.filterClosedAt': 'Fermé le',
  'tickets.filterDateFrom': '{label} du',
  'tickets.filterDateTo': '{label} au',
  'tickets.filterDateTo2': 'au',
  'tickets.filterAny': 'Tous',
  'tickets.chipFieldStatus': 'Statut',
  'tickets.chipFieldPriority': 'Priorité',
  'tickets.chipFieldGroup': 'Groupe',
  'tickets.chipFieldAssignee': 'Responsable',
  'tickets.chipValueGroup': 'Groupe',
  'tickets.chipValueUnassigned': 'Non attribué',
  'common.clearSearch': 'Effacer la recherche',
  'common.name': 'Nom',
  'common.role': 'Rôle',
  'common.groups': 'Groupes',
  'common.tickets': 'Tickets',
  'common.lastSeen': 'Vu pour la dernière fois',
  'common.actions': 'Actions',
  'common.minutesAgo': 'il y a {count} min',
  'common.hoursAgo': 'il y a {count} h',
  'common.daysAgo': 'il y a {count} j',
  'common.noPagePermission': "Vous n'avez pas la permission d'accéder à cette page.",
  'common.roleNoPermission': "Votre rôle n'a pas la permission d'accéder à cette page.",
  'common.requestFailed': 'La requête a échoué. Veuillez réessayer.',
  'common.unexpectedError': 'Une erreur inattendue s’est produite',
  'shell.skipToMain': 'Passer au contenu principal',
  'shell.homeLabel': 'Accueil Suzuki Support Desk',
  'shell.userMenu': 'Menu utilisateur',
  'shell.unread': '{count} non lu(s)',
  'shell.notificationDescription': 'Les nouvelles attributions, réponses et alertes SLA apparaîtront ici.',
  'auth.enterAuthenticatorCode': 'Entrez le code à 6 chiffres de votre application d’authentification',
  'auth.verifying': 'Vérification…',
  'auth.setupAuthenticator': 'Configurer l’authentificateur',
  'auth.scanAuthenticator': 'Scannez ce code avec votre application d’authentification (Google Authenticator, Authy, etc.)',
  'auth.authenticatorSetupQr': 'Code QR de configuration de l’authentificateur',
  'auth.verificationCodeFromAuthenticator': 'Code de vérification de l’authentificateur',
  'auth.verifyAndComplete': 'Vérifier et terminer la configuration',
  'auth.loadingSetup': 'Chargement de la configuration…',
  'auth.setNewPassword': 'Définir un nouveau mot de passe',
  'auth.temporaryPasswordExpired': 'Votre mot de passe temporaire a expiré. Veuillez définir un nouveau mot de passe.',
  'auth.newPassword': 'Nouveau mot de passe',
  'auth.confirmPassword': 'Confirmer le mot de passe',
  'auth.settingPassword': 'Définition du mot de passe…',
  'auth.setPassword': 'Définir le mot de passe',
  'auth.passwordRequirements': '8 caractères minimum, majuscule, minuscule, chiffre et symbole requis',
  'auth.tooManyAttempts': 'Trop de tentatives de connexion. Veuillez réessayer plus tard.',
  'auth.invalidCredentials': 'E-mail ou mot de passe invalide',
  'auth.passwordsDoNotMatch': 'Les mots de passe ne correspondent pas',
  'auth.passwordMinimum': 'Le mot de passe doit comporter au moins {count} caractères',
  'auth.resetTitle': 'Réinitialisez votre mot de passe',
  'auth.resetSubtitle': 'Entrez votre e-mail et nous vous envoyons un lien de réinitialisation',
  'auth.checkEmail': 'Consultez votre e-mail pour le lien de réinitialisation',
  'auth.checkCode': 'Consultez votre e-mail pour le code de vérification, puis continuez ci-dessous.',
  'auth.continueToReset': 'Continuer pour réinitialiser votre mot de passe',
  'auth.sendResetLink': 'Envoyer le lien de réinitialisation',
  'auth.sending': 'Envoi…',
  'auth.resetSuccess': 'Votre mot de passe a été réinitialisé avec succès.',
  'auth.goToLogin': 'Aller à la connexion',
  'auth.missingResetToken': 'Jeton de réinitialisation manquant. Veuillez utiliser le lien de votre e-mail.',
  'auth.enterCodeFromEmail': 'Entrez le code de vérification envoyé à votre e-mail',
  'auth.codeFromEmail': 'Entrer le code de l’e-mail',
  'auth.emailRequired': 'L’e-mail est requis',
  'auth.codeRequired': 'Le code de vérification est requis',
  'auth.missingToken': 'Jeton de réinitialisation manquant',
  'auth.failedReset': 'Échec de la réinitialisation du mot de passe.',
  'auth.resetting': 'Réinitialisation…',
  'auth.resetPassword': 'Réinitialiser le mot de passe',
  'auth.looksGood': 'Ça semble bon',
  'auth.needCharacters': 'Il faut au moins {count} caractères',
  'auth.passwordFormat': '{count} caractères minimum, majuscule, minuscule, chiffre et symbole requis',
  'agents.description': 'Les personnes qui traitent les tickets. Attribuez un rôle pour contrôler ce qu’elles peuvent faire, et des groupes pour contrôler ce qu’elles voient.',
  'agents.searchAria': 'Rechercher des agents',
  'agents.countOne': '{count} agent',
  'agents.countMany': '{count} agents',
  'agents.ticketOne': '{count} ticket',
  'agents.ticketMany': '{count} tickets',
  'agents.noGroups': 'Aucun groupe',
  'agents.lifecycle': 'Cycle de vie de l’agent',
  'agents.tryDifferent': 'Essayez un autre nom ou une autre adresse e-mail.',
  'agents.useNewAgent': 'Utilisez Nouvel agent pour ajouter quelqu’un, ou changez d’onglet pour voir d’autres agents.',
  'agents.agent': 'Agent',
  'agents.noRole': 'Aucun rôle',
  'agents.openTicketsTitle': 'Tickets ouverts actuellement attribués à cet agent',
  'agents.moreActions': 'Plus d’actions pour {name}',
  'agents.confirmDeleteTitle': 'Supprimer {name} ?',
  'agents.confirmDeleteDescription': 'Cette action est irréversible. Les agents liés à des tickets ne peuvent pas être supprimés ; désactivez-les à la place.',
  'agents.confirmDeleteLabel': 'Supprimer l’agent',
  'agents.agentsVsCollaborators': 'Agents contre collaborateurs',
  'agents.agentsVsCollaboratorsBody': 'Les agents de support traitent les tickets au quotidien. Les collaborateurs ont un rôle de collaborateur et sont généralement des experts sollicités sur des tickets individuels sans accès agent complet.',
  'agents.deactivateVsDelete': 'Désactiver contre supprimer',
  'agents.deactivateVsDeleteBody': 'La désactivation conserve l’historique et la propriété des tickets mais bloque la connexion. La suppression est définitive et ne fonctionne que si l’agent n’a aucun ticket lié.',
  'agents.newTitle': 'Nouvel agent',
  'agents.editTitle': 'Modifier l’agent',
  'agents.temporaryPassword': 'Mot de passe temporaire',
  'agents.passwordHelp': 'Au moins 12 caractères. L’agent peut le modifier après connexion.',
  'agents.timezoneHelp': 'Chaque date et heure vue par cet agent est affichée dans ce fuseau horaire.',
  'agents.languageHelp': 'Traduit l’interface côté agent. Les réponses aux tickets et le contenu client ne sont pas traduits.',
  'agents.signaturePlaceholder': 'Ajoutée aux réponses sortantes',
  'agents.roleHelp': 'Détermine ce que cet agent peut faire.',
  'agents.manageRoles': 'Gérer les rôles',
  'agents.activeHelp': 'Actif — décocher bloque la connexion sans supprimer l’agent',
  'agents.groupHelp': 'Ajoutez cet agent à un groupe depuis l’écran Groupes pour contrôler les tickets qu’il voit.',
  'agents.about': 'À propos de cet agent',
  'agents.aboutBody': 'Le nom, l’e-mail, le téléphone, le fuseau horaire, la langue et la signature identifient l’agent et personnalisent son espace de travail. Le rôle déterminine ce qu’il peut faire ; l’appartenance à un groupe déterminine les tickets qu’il voit.',
  'dashboard.trendsDescription': 'Création de tickets par heure UTC, comparée à hier.',
  'dashboard.chartAria': 'Volume de tickets par heure UTC, aujourd’hui contre hier',
  'dashboard.dataUnavailable': 'Les données du tableau de bord ne sont pas disponibles.',
  'dashboard.loadError': 'Impossible de charger les données du tableau de bord. Veuillez réessayer.',
  'notifications.noType': 'Aucune notification de ce type',
  'notifications.allTypesHint': 'Choisissez « Tous les types » ci-dessus pour voir le reste de votre historique.',
  'notifications.emptyDescription': 'Les attributions, réponses et alertes SLA arrivent ici. Ajustez celles qui envoient aussi un e-mail dans les préférences de notifications.',
  'preferences.digestWarning': 'Vous utilisez le résumé quotidien, donc ces paramètres sont ignorés jusqu’à sa désactivation.',
  'preferences.assignedEvent': 'Un ticket vous est attribué',
  'preferences.replyEvent': 'Un ticket dont vous faites partie reçoit une réponse',
  'preferences.noteEvent': 'Une note privée est ajoutée',
  'preferences.slaWarningEvent': 'Le SLA approche de son échéance',
  'preferences.slaBreachEvent': 'Le SLA est violé',
  'preferences.slaEscalationEvent': 'Le SLA escalade après l’échéance',
  'preferences.mentionEvent': 'Vous êtes mentionné sur un ticket',

  'ticketDetail.back': 'Retour',
  'ticketDetail.follow': 'Suivre',
  'ticketDetail.following': 'Suivi',
  'ticketDetail.hideActivities': 'Masquer les activités',
  'ticketDetail.activitiesButton': 'Activités',
  'ticketDetail.attachmentsCount': 'Pièces jointes ({count})',
  'ticketDetail.threadAria': 'Fil du ticket',
  'ticketDetail.conversationsTabLabel': 'Conversations',
  'ticketDetail.activitiesTabLabel': 'Activités',
  'ticketDetail.noRepliesYet': 'Pas encore de réponses',
  'ticketDetail.noRepliesDescription': "Utilisez l'éditeur ci-dessous pour répondre au demandeur ou ajouter une note interne.",
  'ticketDetail.privateNote': 'Note privée',
  'ticketDetail.forward': 'Transféré',
  'ticketDetail.uploadingAria': 'Envoi en cours',
  'ticketDetail.uploadingProgress': 'Envoi de {uploading} sur {total} fichier(s)…',
  'ticketDetail.uploadsFailed': '{count} envoi(s) échoué(s)',
  'ticketDetail.retry': 'Réessayer',
  'ticketDetail.dismiss': 'Ignorer',
  'ticketDetail.noActivityYet': "Pas encore d'activité",
  'ticketDetail.noActivityDescription': "Les changements de statut, d'agent et de SLA seront listés ici au fil du ticket.",
  'ticketDetail.requester': 'Demandeur',
  'ticketDetail.properties': 'Propriétés',
  'ticketDetail.updating': 'Mise à jour…',
  'ticketDetail.update': 'Mettre à jour',
  'ticketDetail.tags': 'Étiquettes',
  'ticketDetail.relationships': 'Relations',
  'ticketDetail.parentTicket': 'Ticket parent',
  'ticketDetail.unlink': 'Dissocier',
  'ticketDetail.noParentTicket': 'Aucun ticket parent',
  'ticketDetail.childTicketsCount': 'Tickets enfants ({count})',
  'ticketDetail.noChildTickets': 'Aucun ticket enfant',
  'ticketDetail.findTicket': 'Trouver un ticket',
  'ticketDetail.ticketSearchPlaceholder': 'Numéro de ticket ou objet',
  'ticketDetail.searchButton': 'Rechercher',
  'ticketDetail.setParent': 'Définir comme parent',
  'ticketDetail.mergeIntoAction': 'Fusionner avec',
  'ticketDetail.splitIntoChild': 'Diviser en ticket enfant',
  'ticketDetail.newTicketSubjectPlaceholder': 'Objet du nouveau ticket',
  'ticketDetail.splitButton': 'Diviser',
  'ticketDetail.copyAttachments': 'Copier les pièces jointes',
  'ticketDetail.copyConversationHistory': "Copier l'historique de conversation",
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'En pause',
  'ticketDetail.editButton': 'Modifier',
  'ticketDetail.setResolutionDueDate': "Définir l'échéance de résolution",
  'ticketDetail.pickDateTime': 'Choisir date et heure',
  'ticketDetail.resolutionDueLabel': 'Échéance de résolution',
  'ticketDetail.saveSla': 'Enregistrer le SLA',
  'ticketDetail.savingSla': 'Enregistrement…',
  'ticketDetail.noSlaPolicy': 'Aucune politique SLA appliquée à ce ticket.',
  'ticketDetail.firstResponse': 'Première réponse',
  'ticketDetail.resolution': 'Résolution',
  'ticketDetail.done': 'Terminé',
  'ticketDetail.pausedSince': 'En pause depuis {date}',
  'ticketDetail.escalation': 'Escalade',
  'ticketDetail.escalatedLevel2': 'Escaladé (Niveau 2)',
  'ticketDetail.escalated': 'Escaladé',
  'ticketDetail.dueDateOverridden': 'Échéance modifiée manuellement par un administrateur.',
  'ticketDetail.dates': 'Dates',
  'ticketDetail.created': 'Créé',
  'ticketDetail.updated': 'Mis à jour',
  'ticketDetail.resolved': 'Résolu',
  'ticketDetail.closed': 'Fermé',
  'ticketDetail.loadErrorTitle': 'Impossible de charger ce ticket',
  'ticketDetail.notFound': 'Ticket introuvable',
  'ticketDetail.confirmMergeTitle': 'Fusionner le ticket n° {source} avec le n° {target} ?',
  'ticketDetail.confirmMergeDescription': 'Le ticket actuel sera fermé. Cette action est irréversible.',
  'ticketDetail.confirmMergeLabel': 'Fusionner le ticket',
  'ticketDetail.updateSuccess': 'Ticket mis à jour',
  'ticketDetail.updateError': 'Impossible de mettre à jour le ticket',
  'ticketDetail.pickDateTitle': 'Choisir une date',
  'ticketDetail.pickDateDescription': 'Choisissez une échéance de résolution.',
  'ticketDetail.slaUpdateSuccess': 'SLA mis à jour',
  'ticketDetail.slaUpdateError': 'Impossible de mettre à jour le SLA',
  'ticketDetail.searchError': 'Impossible de rechercher des tickets',
  'ticketDetail.parentUpdateError': 'Impossible de mettre à jour le ticket parent',
  'ticketDetail.mergeSuccess': 'Fusionné avec le n° {number}',
  'ticketDetail.mergeError': 'Impossible de fusionner le ticket',
  'ticketDetail.splitSuccess': 'Division du ticket créée',
  'ticketDetail.splitError': 'Impossible de diviser le ticket',
  'ticketDetail.downloadError': 'Impossible de télécharger la pièce jointe',
  'ticketDetail.followSuccess': 'Suit maintenant le ticket',
  'ticketDetail.unfollowSuccess': 'Ne suit plus le ticket',
  'ticketDetail.watcherError': 'Impossible de mettre à jour le statut de suivi',
  'ticketDetail.fieldsLoadError': 'Impossible de charger les champs du ticket',
  'ticketDetail.overdueBy': 'En retard de {label}',
  'ticketDetail.dueLeft': '{label} restant',
  'ticketDetail.presetToday': "Aujourd'hui",
  'ticketDetail.presetTomorrow': 'Demain',
  'ticketDetail.presetThisWeek': 'Cette semaine',
  'ticketDetail.presetNextWeek': 'La semaine prochaine',
  'ticketDetail.presetThisMonth': 'Ce mois-ci',
  'ticketDetail.eventTicketCreated': 'Ticket créé',
  'ticketDetail.eventStatusUpdated': 'Statut mis à jour',
  'ticketDetail.eventAgentUpdated': 'Agent mis à jour',
  'ticketDetail.eventSlaUpdated': 'SLA mis à jour',
  'ticketDetail.eventTicketMerged': 'Ticket fusionné',
  'ticketDetail.eventMergeReceived': 'Fusion reçue',
  'ticketDetail.eventTicketSplit': 'Ticket divisé',
  'ticketDetail.eventUpdated': 'Mis à jour',
  'ticketDetail.eventSplitContentCopied': 'Contenu divisé copié',
  'ticketDetail.eventReplySent': 'Réponse envoyée',
  'ticketDetail.eventNoteAdded': 'Note ajoutée',
  'ticketDetail.eventCustomerReplied': 'Le client a répondu',
  'ticketDetail.eventTicketDeleted': 'Ticket supprimé',
  'preferences.createdEvent': 'Un ticket a été créé',
  'preferences.pendingInputEvent': 'Un ticket attend votre réponse',
  'preferences.resolvedEvent': 'Un ticket est résolu',
  'agents.assignGroups': 'Attribuer des groupes',
  'agents.assignGroupsHelp': 'L’appartenance aux groupes détermine les tickets que cet agent peut voir.',
  'agents.selectGroups': 'Sélectionner des groupes',
  'agents.ticketVisibility': 'Visibilité des tickets',
  'agents.ticketVisibilityHelp': 'Choisissez une limite plus étroite par agent ou utilisez la valeur par défaut du rôle. Les autorisations du rôle contrôlent toujours ce que l’agent peut faire.',
  'agents.scopeRoleDefault': 'Utiliser la valeur par défaut du rôle',
  'agents.scopeRoleDefaultHelp': 'Hériter de la visibilité par défaut configurée pour ce rôle.',
  'agents.scopeAll': 'Tous les tickets',
  'agents.scopeAllHelp': 'Voir tous les tickets non supprimés de ce compte.',
  'agents.scopeGroup': 'Tickets d’un groupe',
  'agents.scopeGroupHelp': 'Voir les tickets attribués aux groupes auxquels cet agent appartient.',
  'agents.scopeAssigned': 'Tickets attribués',
  'agents.scopeAssignedHelp': 'Voir les tickets attribués directement à cet agent.',
  'agents.scopeCollaboratorHelp': 'Les collaborateurs restent limités aux tickets de leurs groupes L1.',
  'nav.jira': 'Intégration Jira',
  'notifications.groupAssigned': 'Affectation de groupe',
  'notifications.groupMemberAdded': 'Ajouté à un groupe',
  'preferences.groupAssignedEvent': 'Un ticket est affecté à l’un de vos groupes',
  'preferences.groupMemberAddedEvent': 'Vous êtes ajouté à un groupe de support',
  'ui.select': 'Sélectionner…',
  'ui.any': 'Tous',
  'ui.typeToSearch': 'Saisissez pour rechercher…',
  'ui.noResults': 'Aucun résultat trouvé',
  'ui.clearSelection': 'Effacer la sélection',
  'ui.removeItem': 'Retirer {label}',
  'ui.pressEnterToUse': 'Appuyez sur Entrée pour utiliser cette valeur',
  'ui.removeFilter': 'Retirer le filtre {field} : {value}',
  'ui.removeTag': 'Retirer l’étiquette {label}',
  'ui.retry': 'Réessayer',
  'ui.errorTitle': 'Impossible de charger ce contenu',
  'ui.errorMessage': 'Vérifiez votre connexion et réessayez.',
  'ui.reference': 'Référence : {id}',
  'ui.thisArea': 'cette zone',
  'ui.noAccess': 'Vous n’avez pas accès à {area}',
  'ui.noAccessHint': 'Demandez à un administrateur de vous accorder l’autorisation requise.',
  'ui.actionFailed': 'Impossible d’effectuer cette action. Réessayez.',
  'ui.slaPaused': 'SLA en pause',
  'ui.filteredEmptyTitle': 'Aucun ticket ne correspond à ces filtres',
  'ui.filteredEmptyDescription': 'Essayez de retirer un filtre ou d’élargir la période.',
  'ui.clearFilters': 'Effacer les filtres',
  'pagination.noResults': 'Aucun résultat',
  'pagination.showing': 'Affichage de {first}–{last} sur {total}',
  'pagination.resultsPerPage': 'Résultats par page',
  'pagination.perPage': '{count} par page',
  'pagination.previous': 'Précédent',
  'pagination.next': 'Suivant',
  'pagination.previousAria': 'Page précédente',
  'pagination.nextAria': 'Page suivante',
  'pagination.pageOf': 'Page {page} sur {total}',
  'status.open': 'Ouvert',
  'status.to_be_prioritised': 'À prioriser',
  'status.work_in_progress': 'En cours',
  'status.assigned_to_ai_agent': 'Affecté à l’agent IA',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'En attente',
  'status.awaiting_user_reply': 'En attente de réponse de l’utilisateur',
  'status.awaiting_resolution_confirmation': 'En attente de confirmation de résolution',
  'status.on_hold': 'En pause',
  'status.pending_production_release': 'En attente de mise en production',
  'status.product_cr': 'CR produit',
  'status.reopened': 'Rouvert',
  'status.issue_fixed': 'Problème corrigé',
  'status.resolved': 'Résolu',
  'status.closed': 'Fermé',
  'status.unknown': 'Inconnu',
  'priority.low': 'Faible',
  'priority.medium': 'Moyenne',
  'priority.high': 'Élevée',
  'priority.urgent': 'Urgente',
  'source.email': 'E-mail',
  'source.portal': 'Portail',
  'source.phone': 'Téléphone',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Chat web',
  'source.web_form': 'Formulaire web',
  'source.forum': 'Forum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget de commentaires',
  'source.outbound_email': 'E-mail sortant',
  'source.ecommerce': 'E-commerce',
  'source.bot': 'Bot',
  'source.instagram_message': 'Message Instagram',
  'source.instagram_comment': 'Commentaire Instagram',
  'source.facebook_message': 'Message Facebook',
  'source.facebook_comment': 'Commentaire Facebook',
  'source.mobile_chat_sdk': 'SDK de chat mobile',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Vues enregistrées',
  'savedViews.saveCurrent': 'Enregistrer les filtres actuels comme vue',
  'savedViews.namePlaceholder': 'Nom de la vue...',
  'savedViews.nameAria': 'Nom de la vue',
  'savedViews.empty': 'Aucune vue enregistrée. Appliquez des filtres et enregistrez-les ici.',
  'savedViews.listAria': 'Liste des vues enregistrées',
  'savedViews.rename': 'Renommer la vue « {name} »',
  'savedViews.delete': 'Supprimer la vue « {name} »',
  'export.title': 'Exporter les tickets',
  'export.loadError': 'Impossible de charger la liste des champs d’export.',
  'export.failed': 'L’export a échoué. Veuillez réessayer.',
  'export.pdfFailed': 'L’export PDF a échoué. Veuillez réessayer.',
  'export.fieldsSelectedOne': '{count} champ sélectionné',
  'export.fieldsSelectedMany': '{count} champs sélectionnés',
  'export.fieldsTotalOne': '{count} champ au total',
  'export.fieldsTotalMany': '{count} champs au total',
  'export.selectAllFields': 'Sélectionner tous les champs',
  'export.exportingOne': 'Export d’un ticket sélectionné.',
  'export.exportingMany': 'Export de {count} tickets sélectionnés.',
  'export.pdfZip': 'Télécharger en PDF (.zip, {count} fichiers)',
  'export.pdf': 'Télécharger en PDF',
  'export.pdfZipHint': 'Génère un PDF par ticket et les compresse dans un seul téléchargement ZIP.',
  'export.pdfHint': 'Génère un PDF unique avec les propriétés du ticket et le fil de conversation public.',
  'export.formatLabel': 'Exporter en (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Chargement de la liste des champs…',
  'export.ticketFields': 'Champs du ticket',
  'export.contactFields': 'Champs du contact',
  'export.companyFields': 'Champs de l’entreprise',
  'export.exporting': 'Export en cours…',
  'newTicket.title': 'Créer un ticket',
  'newTicket.description': 'Choisissez un formulaire enregistré et renseignez ses champs.',
  'newTicket.form': 'Formulaire de ticket',
  'newTicket.noForms': 'Aucun formulaire de ticket disponible. Configurez un formulaire avant de créer un ticket.',
  'newTicket.loadFormsError': 'Impossible de charger les formulaires de ticket',
  'newTicket.loadFormError': 'Impossible de charger le formulaire de ticket sélectionné',
  'newTicket.addCc': 'Ajouter en CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Retirer {name}',
  'newTicket.requesterRequired': 'Le demandeur est obligatoire',
  'newTicket.subjectRequired': 'L’objet est obligatoire',
  'newTicket.createFailed': 'Échec de la création du ticket',
  'newTicket.noFormTitle': 'Aucun formulaire de ticket disponible',
  'newTicket.noFormDescription': 'Créez un formulaire de ticket dans les Paramètres, puis revenez pour ouvrir un ticket.',
  'newTicket.noFieldsTitle': 'Ce formulaire n’a pas encore de champs',
  'newTicket.noFieldsDescription': 'Ajoutez des champs au formulaire dans les Paramètres, puis rechargez cette page.',
  'newTicket.creating': 'Création…',
  'newTicket.submit': 'Créer un ticket',
  'fields.required': '{label} est obligatoire',
  'fields.selectParentFirst': 'Sélectionnez d’abord une valeur parente...',
  'fields.selectPlaceholder': 'Sélectionner {label}...',
  'fields.enterPlaceholder': 'Saisir {label}...',
  'fields.optionsLoadError': 'Impossible de charger les options de {label}',
  'fields.label.requester': 'Demandeur',
  'fields.label.subject': 'Objet',
  'fields.label.description': 'Description',
  'fields.label.status': 'Statut',
  'fields.label.priority': 'Priorité',
  'fields.label.source': 'Source',
  'fields.label.ticket_type': 'Type',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Groupe',
  'fields.label.internal_agent': 'Agent interne',
  'fields.label.internal_group': 'Groupe interne',
  'fields.label.company': 'Entreprise',
  'editor.defaultPlaceholder': 'Saisissez ici...',
  'editor.ariaLabel': 'Éditeur de texte enrichi',
  'editor.toolbarAria': 'Mise en forme du texte',
  'editor.bold': 'Gras (Ctrl+B)',
  'editor.italic': 'Italique (Ctrl+I)',
  'editor.underline': 'Souligné (Ctrl+U)',
  'editor.strikethrough': 'Barré',
  'editor.heading1': 'Titre 1',
  'editor.heading2': 'Titre 2',
  'editor.textColor': 'Couleur du texte',
  'editor.highlight': 'Surlignage',
  'editor.bulletList': 'Liste à puces',
  'editor.numberedList': 'Liste numérotée',
  'editor.blockquote': 'Citation',
  'editor.codeBlock': 'Bloc de code',
  'editor.insertLink': 'Insérer un lien',
  'editor.insertImage': 'Insérer une image',
  'editor.insertTable': 'Insérer un tableau',
  'editor.mention': 'Mentionner quelqu’un',
  'editor.undo': 'Annuler (Ctrl+Z)',
  'editor.redo': 'Rétablir (Ctrl+Shift+Z)',
  'editor.attach': 'Joindre un fichier',
  'editor.noAgents': 'Aucun agent trouvé',
  'editor.mentionSuggestions': 'Suggestions de mention',
  'editor.dialogLinkTitle': 'Insérer un lien',
  'editor.dialogImageTitle': 'Insérer une image',
  'editor.linkHint': 'Saisissez une URL HTTP(S), mailto, ancre ou relative.',
  'editor.imageHint': 'Saisissez une URL d’image HTTP(S) ou relative.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Saisissez une URL HTTP(S), mailto, ancre ou relative valide.',
  'editor.invalidImage': 'Saisissez une URL d’image HTTP(S) ou relative valide.',
  'editor.selectTextForLink': 'Sélectionnez du texte avant d’ajouter un lien.',
  'editor.imageInsertFailed': 'Impossible d’insérer l’image ici.',
  'editor.insertLinkAction': 'Insérer le lien',
  'editor.insertImageAction': 'Insérer l’image',
  'search.dialogAria': 'Recherche globale',
  'search.placeholder': 'Rechercher des tickets, contacts...',
  'search.aria': 'Rechercher',
  'search.close': 'Fermer la recherche',
  'search.noMatches': 'Aucun résultat pour « {query} »',
  'search.noMatchesHint': 'Essayez un numéro de ticket, un e-mail de contact ou un nom d’entreprise.',
  'search.hintBefore': 'Saisissez au moins 2 caractères pour rechercher. Appuyez sur',
  'search.hintAfter': 'pour fermer.',

  'td.system': 'Système',
  'td.actionCreatedTicket': 'a créé le ticket',
  'td.actionUpdatedFields': 'a mis à jour {fields}',
  'td.fieldStatus': 'le statut',
  'td.fieldPriority': 'la priorité',
  'td.fieldSource': 'la source',
  'td.fieldType': 'le type',
  'td.fieldGroup': 'le groupe',
  'td.fieldAgent': 'l’agent',
  'td.fieldCompany': 'l’entreprise',
  'td.fieldContact': 'le contact',
  'td.fieldSubject': 'l’objet',
  'td.fieldDescription': 'la description',
  'td.fieldProduct': 'le produit',
  'td.fieldResolutionDue': 'l’échéance de résolution',
  'td.fieldFirstResponseDue': 'l’échéance de première réponse',
  'td.fieldTags': 'les étiquettes',
  'td.fieldParentTicket': 'le ticket parent',
  'td.eventCreated': '{actor} a créé un nouveau ticket',
  'td.eventCreatedLinked': '{actor} a créé un nouveau ticket et l’a lié à un ticket parent',
  'td.eventSplit': '{actor} a scindé ce ticket et créé le ticket enfant{ref}',
  'td.eventMergeReceived': '{actor} a fusionné un autre ticket dans ce ticket{ref}',
  'td.eventMerged': '{actor} a fusionné ce ticket dans un autre ticket{ref}',
  'td.eventSplitCopied': '{actor} a copié {conversations} et {attachments}',
  'td.conversationsOne': '{count} conversation',
  'td.conversationsMany': '{count} conversations',
  'td.attachmentsOne': '{count} pièce jointe',
  'td.attachmentsMany': '{count} pièces jointes',
  'td.eventUpdatedFields': '{actor} a mis à jour {fields}',
  'td.invalidSlaState': 'Le serveur a renvoyé un état SLA non valide.',
  'td.slaRefreshError': 'Impossible d’actualiser les chronomètres SLA.',
  'td.descriptionUpdated': 'Description mise à jour',
  'td.descriptionUpdateError': 'Impossible de mettre à jour la description',
  'td.descriptionUpdateFailed': 'Échec de la mise à jour de la description',
  'td.entryUpdated': 'Entrée mise à jour',
  'td.entryUpdateError': 'Impossible de mettre à jour l’entrée',
  'td.updateFailed': 'Échec de la mise à jour',
  'td.loadOlderError': 'Impossible de charger les conversations plus anciennes',
  'td.loadFailed': 'Échec du chargement',
  'td.slaUpdateFailed': 'Échec de la mise à jour du SLA',
  'td.reasonTooLong': 'Le motif ne doit pas dépasser 500 caractères.',
  'td.invalidDateTime': 'Choisissez une date et une heure valides.',
  'td.slaDeadlineUpdated': 'Échéance SLA mise à jour',
  'td.slaConflict': 'Le ticket a changé pendant que vous modifiiez les données SLA. Rechargez avant de réessayer.',
  'td.slaClearFailed': 'Échec de la suppression du SLA',
  'td.slaTargetCleared': 'Objectif SLA supprimé',
  'td.slaClearError': 'Impossible de supprimer l’objectif SLA',
  'td.noDescription': 'Aucune description ajoutée pour le moment.',
  'td.editDescriptionAria': 'Modifier la description du ticket',
  'td.download': 'Télécharger',
  'td.downloadFile': 'Télécharger {fileName}',
  'td.loadOlder': '↓ +{count} conversation',
  'td.loadOlderMany': '↓ +{count} conversations',
  'td.edited': '(modifié)',
  'td.privateThread': 'Fil privé',
  'td.propertiesAria': 'Propriétés du ticket',
  'td.expandProperties': 'Développer les propriétés',
  'td.collapseProperties': 'Réduire les propriétés',
  'td.metric': 'Indicateur',
  'td.firstResponseOption': 'Première réponse',
  'td.resolutionOption': 'Résolution',
  'td.overrideHint': 'Définissez une échéance forcée faisant autorité côté serveur. Le motif est conservé dans l’historique SLA.',
  'td.deadline': 'Échéance',
  'td.reasonOptional': 'Motif (facultatif)',
  'td.reasonPlaceholder': 'Exception approuvée ou contexte opérationnel',
  'td.clearResolutionOverride': 'Supprimer la dérogation de résolution',
  'td.clearEscalationTarget': 'Supprimer la cible d’escalade',
  'td.toolsAria': 'Outils du ticket et contact',
  'td.ticketContext': 'Contexte du ticket',
  'td.knowledgeBase': 'Base de connaissances',
  'td.shortcutsAria': 'Raccourcis du contexte du ticket',
  'td.showContext': 'Afficher le contexte du ticket',
  'td.hideContext': 'Masquer le contexte du ticket',
  'td.openRow': 'Ouvrir {label}',
  'td.editTicket': 'Modifier le ticket',
  'td.searchContactPlaceholder': 'Rechercher un contact…',
  'td.describePlaceholder': 'Décrivez le problème…',
  'td.noAttachments': 'Aucune pièce jointe',

  'tp.api.csrfUnavailable': 'Impossible d’établir la protection CSRF',
  'tp.api.noMfaChallenge': 'Aucune vérification MFA active',
  'tp.api.noMfaSetup': 'Aucune configuration MFA active',
  'tp.api.noNewPasswordChallenge': 'Aucune demande de nouveau mot de passe active',
  'tp.articles.isLinkedAria': '{title} est lié comme solution',
  'tp.articles.linkAria': 'Lier {title} comme solution',
  'tp.articles.linkAsSolution': 'Lier comme solution',
  'tp.articles.linkedAsSolution': 'Lié comme solution',
  'tp.articles.none': 'Aucun article suggéré pour ce ticket.',
  'tp.articles.title': 'Articles suggérés',
  'tp.articles.views': '{count} vues',
  'tp.attachment.loadingPreview': 'Chargement de l’aperçu…',
  'tp.attachment.previewUnavailable': 'Aperçu indisponible',
  'tp.charts.noData': 'Aucune donnée de graphique pour cette période.',
  'tp.charts.noRecords': 'Aucun enregistrement pour cette période.',
  'tp.charts.period': 'Période',
  'tp.charts.showingTop': 'Affichage des {shown} premiers segments sur {total}.',
  'tp.common.cancel': 'Annuler',
  'tp.common.clear': 'Effacer',
  'tp.common.loading': 'Chargement…',
  'tp.common.send': 'Envoyer',
  'tp.common.sending': 'Envoi…',
  'tp.common.system': 'Système',
  'tp.convActions.edit': 'Modifier',
  'tp.convActions.thread': 'Démarrer un fil',
  'tp.dashboard.new': 'Nouveau',
  'tp.dashboard.select': 'Sélectionner un tableau de bord',
  'tp.forward.failed': 'Échec du transfert',
  'tp.forward.forwarded': 'Ticket transféré',
  'tp.forward.forwarding': 'Transfert en cours…',
  'tp.forward.forwardingMany': 'Transfert de {count} conversations :',
  'tp.forward.forwardingOne': 'Transfert d’1 conversation :',
  'tp.forward.message': 'Message',
  'tp.forward.messagePlaceholder': 'Ajouter un message (facultatif)…',
  'tp.forward.noContacts': 'Aucun contact trouvé — saisissez une adresse e-mail complète',
  'tp.forward.recipientEmail': 'E-mail du destinataire',
  'tp.forward.recipientInvalid': 'Saisissez une adresse e-mail de destinataire valide',
  'tp.forward.recipientRequired': 'L’e-mail du destinataire est requis',
  'tp.forward.searchContact': 'Rechercher un contact ou saisir un e-mail…',
  'tp.forward.title': 'Transférer',
  'tp.forward.to': 'À',
  'tp.forward.useThisEmail': 'Appuyez sur Entrée ou cliquez sur Transférer pour utiliser cet e-mail',
  'tp.jira.addOptional': 'Ajouter des champs facultatifs',
  'tp.jira.createAndLink': 'Créer et lier le ticket',
  'tp.jira.createIssue': 'Créer un ticket',
  'tp.jira.createTitle': 'Créer un ticket Jira',
  'tp.jira.describePlaceholder': 'Décrivez le problème…',
  'tp.jira.description': 'Description',
  'tp.jira.development': 'Développement',
  'tp.jira.enterDevelopment': 'Saisir le développement',
  'tp.jira.hideOptional': 'Masquer les champs facultatifs',
  'tp.jira.issueId': 'ID du ticket',
  'tp.jira.issueSummary': 'Résumé du ticket',
  'tp.jira.issueType': 'Type de ticket *',
  'tp.jira.lastSync': 'Dernière synchronisation : {error}',
  'tp.jira.linkIssue': 'Lier le ticket',
  'tp.jira.linkTitle': 'Lier un ticket Jira',
  'tp.jira.linkedIssues': 'Tickets liés',
  'tp.jira.linkedIssuesHint': 'Utilisez des clés de tickets Jira séparées par des virgules.',
  'tp.jira.linkedIssuesPlaceholder': 'ex. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Chargement des champs Jira…',
  'tp.jira.loadingIssueTypes': 'Chargement des types de tickets…',
  'tp.jira.loadingProjects': 'Chargement des projets Jira…',
  'tp.jira.loadingUsers': 'Chargement des utilisateurs Jira…',
  'tp.jira.noLinks': 'Aucun ticket Jira lié à ce ticket pour le moment.',
  'tp.jira.noneFound': 'Aucun ticket Jira trouvé.',
  'tp.jira.notAvailableProject': 'Non disponible pour ce projet',
  'tp.jira.projects': 'Projets *',
  'tp.jira.refresh': 'Actualiser',
  'tp.jira.refreshFields': 'Actualiser les champs Jira',
  'tp.jira.reporter': 'Rapporteur',
  'tp.jira.requestFailed': 'La requête Jira a échoué. Veuillez réessayer.',
  'tp.jira.searchBy': 'Rechercher par :',
  'tp.jira.searchIssue': 'Rechercher un ticket',
  'tp.jira.searchIssuePlaceholder': 'Rechercher un ticket…',
  'tp.jira.searchUsers': 'Rechercher des utilisateurs Jira',
  'tp.jira.searching': 'Recherche dans Jira…',
  'tp.jira.selectIssueType': 'Sélectionner un type de ticket',
  'tp.jira.selectProject': 'Sélectionner un projet',
  'tp.jira.summary': 'Résumé *',
  'tp.jira.syncOff': 'Synchronisation désactivée',
  'tp.jira.syncOn': 'Synchronisation activée',
  'tp.jira.syncStatus': 'Synchroniser le statut du ticket avec Jira',
  'tp.jira.unassigned': 'Non attribué',
  'tp.jira.unlink': 'Dissocier',
  'tp.jira.unlinkConfirm': 'Dissocier le ticket',
  'tp.jira.unlinkDescription': 'Cela supprime le lien avec le ticket mais ne supprime pas le ticket Jira.',
  'tp.jira.unlinkTitle': 'Dissocier {key} ?',
  'tp.jira.untitled': 'Ticket Jira sans titre',
  'tp.layout.loadingPage': 'Chargement de la page…',
  'tp.notFound.goToDashboard': 'Aller au tableau de bord',
  'tp.notFound.title': 'Page introuvable',
  'tp.portal.brand': 'Support SuzukiDesk',
  'tp.portal.customer': 'Client',
  'tp.reply.addNote': 'Ajouter une note',
  'tp.reply.attachmentNotAdded': 'Pièce jointe non ajoutée',
  'tp.reply.clickToExpand': 'Cliquez pour développer',
  'tp.reply.collapsedNote': 'Ajouter une note interne…',
  'tp.reply.collapsedReply': 'Écrire une réponse ou une note…',
  'tp.reply.conversationType': 'Type de conversation',
  'tp.reply.failedToSend': 'Échec de l’envoi',
  'tp.reply.markNoteAs': 'Marquer la note comme',
  'tp.reply.notVisibleToContact': 'Non visible par le contact',
  'tp.reply.notVisibleToContacts': 'Non visible par les contacts',
  'tp.reply.noteAdded': 'Note ajoutée',
  'tp.reply.notifyTo': 'Notifier',
  'tp.reply.placeholderPrivateNote': 'Ajouter une note privée...',
  'tp.reply.placeholderPublicNote': 'Ajouter une note publique visible par le demandeur...',
  'tp.reply.placeholderReply': 'Saisissez votre réponse...',
  'tp.reply.private': 'Privée',
  'tp.reply.public': 'Publique',
  'tp.reply.removeFile': 'Retirer {name}',
  'tp.reply.replySent': 'Réponse envoyée',
  'tp.reply.searchAgentsToNotify': 'Rechercher des agents à notifier…',
  'tp.reply.sendReply': 'Envoyer la réponse',
  'tp.reply.sending': 'Envoi...',
  'tp.reply.tabNote': 'Note',
  'tp.reply.tabReply': 'Réponse',
  'tp.reply.uploadAttachment': 'Téléverser une pièce jointe',
  'tp.reply.visibleToContact': 'Visible par le contact',
  'tp.reply.visibleToContacts': 'Visible par les contacts',
  'tp.sla.breached': 'Dépassé',
  'tp.sla.cleared': 'Supprimé',
  'tp.sla.configErrorNoDeadline': 'Erreur de configuration SLA. Aucune échéance n’est déduite.',
  'tp.sla.configurationError': 'Erreur de configuration',
  'tp.sla.couldNotLoad': 'Impossible de charger les chronomètres SLA',
  'tp.sla.done': 'Terminé',
  'tp.sla.dueIn': 'Échéance dans {duration}',
  'tp.sla.dueLine': 'Échéance : {date}',
  'tp.sla.dueNow': 'Échéance maintenant',
  'tp.sla.escalated': 'Escaladé',
  'tp.sla.firstResponse': 'Première réponse',
  'tp.sla.invalidDeadline': 'Échéance non valide',
  'tp.sla.mayBeStale': 'Les chronomètres SLA peuvent être obsolètes',
  'tp.sla.noActiveCycle': 'Aucun cycle SLA actif.',
  'tp.sla.noDeadline': 'Aucune échéance',
  'tp.sla.noMetrics': 'Aucun indicateur SLA n’est disponible pour ce cycle.',
  'tp.sla.noPolicy': 'Aucune politique SLA appliquée à ce ticket.',
  'tp.sla.notConfigured': 'Non configuré',
  'tp.sla.notStarted': 'Non démarré',
  'tp.sla.overdueBy': 'En retard de {duration}',
  'tp.sla.overridden': 'Forcé',
  'tp.sla.overrideReason': 'Motif de la dérogation : {reason}',
  'tp.sla.paused': 'En pause',
  'tp.sla.refreshing': 'Actualisation des chronomètres SLA de référence…',
  'tp.sla.resolution': 'Résolution',
  'tp.sla.stopsSla': 'Arrête le SLA',
  'tp.thread.empty': 'Rien n’a encore été envoyé. Votre premier message démarrera ce fil privé.',
  'tp.thread.messageFailed': 'Échec du message',
  'tp.thread.privateThread': 'Fil privé',
  'tp.thread.replyPlaceholder': 'Répondre dans le fil…',
  'tp.thread.someone': 'Quelqu’un',
  'tp.thread.startPrivateThread': 'Démarrer un fil privé',
  'tp.thread.startedBy': '{name} a démarré ce fil',
  'tp.thread.unableToSend': 'Impossible d’envoyer le message',
  'tp.ui.breadcrumb': 'Fil d’Ariane',
  'tp.ui.closePanel': 'Fermer le panneau',
  'tp.ui.dismiss': 'Fermer {title}',

  'dir.loadError': 'Impossible de charger les données. Veuillez réessayer.',
  'dir.contacts.description': 'Contacts clients et historique de leurs demandes de support.',
  'dir.contacts.searchAria': 'Rechercher des contacts',
  'dir.contacts.count': '{count} contacts',
  'dir.contacts.noMatch': 'Aucun contact ne correspond à cette recherche',
  'dir.contacts.none': 'Aucun contact pour le moment',
  'dir.contacts.noneDescription': 'Les contacts apparaissent ici dès que les clients commencent à soumettre des tickets.',
  'dir.company': 'Entreprise',
  'dir.unnamedContact': 'Contact sans nom',
  'dir.contact': 'Contact',
  'dir.contactNotFound': 'Contact introuvable.',
  'dir.confirmDeleteContactTitle': 'Supprimer « {name} » ?',
  'dir.thisContact': 'ce contact',
  'dir.confirmDeleteContactDescription': 'Les contacts ayant des tickets seront désactivés au lieu d’être supprimés définitivement.',
  'dir.deleteContact': 'Supprimer le contact',
  'dir.editProfile': 'Modifier le profil',
  'dir.profile': 'Profil',
  'dir.firstName': 'Prénom',
  'dir.lastName': 'Nom',
  'dir.phone': 'Téléphone',
  'dir.timezone': 'Fuseau horaire',
  'dir.emailLabel': 'E-mail :',
  'dir.phoneLabel': 'Téléphone :',
  'dir.companyLabel': 'Entreprise :',
  'dir.timezoneLabel': 'Fuseau horaire :',
  'dir.recentTickets': 'Tickets récents',
  'dir.noTicketsYet': 'Aucun ticket pour le moment',
  'dir.contactTicketsDescription': 'Les tickets créés par ce contact seront listés ici.',
  'dir.ticket': 'Ticket',
  'dir.subject': 'Objet',
  'dir.status': 'Statut',
  'dir.created': 'Créé',
  'dir.companies.description': 'Organisations liées aux contacts clients et aux tickets.',
  'dir.companies.add': 'Ajouter une entreprise',
  'dir.companies.domain': 'Domaine',
  'dir.companies.create': 'Créer l’entreprise',
  'dir.companies.searchAria': 'Rechercher des entreprises',
  'dir.companies.searchPlaceholder': 'Rechercher des entreprises ou des domaines',
  'dir.companies.noMatch': 'Aucune entreprise ne correspond à cette recherche',
  'dir.companies.addFirst': 'Ajoutez votre première entreprise',
  'dir.companies.tryDifferent': 'Essayez un autre nom d’entreprise ou un autre domaine.',
  'dir.companies.useForm': 'Utilisez le formulaire à côté de cette liste pour créer une entreprise.',
  'dir.companies.contacts': 'Contacts',
  'dir.companies.tickets': 'Tickets',
  'dir.companies.notFound': 'Entreprise introuvable.',
  'dir.companies.confirmDeleteTitle': 'Supprimer « {name} » ?',
  'dir.companies.thisCompany': 'cette entreprise',
  'dir.companies.confirmDeleteDescription': 'L’entreprise ne doit avoir aucun contact ni ticket pour pouvoir être supprimée.',
  'dir.companies.delete': 'Supprimer l’entreprise',
  'dir.companies.noDomain': 'Aucun domaine configuré',
  'dir.companies.contactsCount': 'Contacts ({count})',
  'dir.companies.ticketsCount': 'Tickets ({count})',
  'dir.companies.noContactsDescription': 'Ajoutez un contact et liez-le à cette entreprise pour le voir ici.',
  'dir.companies.noTicketsDescription': 'Les tickets créés par les contacts de cette entreprise seront listés ici.',
  'dir.trendsCreatedHour': 'Date de création - Heure de la journée',
  'dir.reports.loadError': 'Impossible de charger ce rapport. Veuillez réessayer.',
  'dir.reports.volume': 'Volume de tickets',
  'dir.reports.sla': 'Conformité SLA',
  'dir.reports.agents': 'Performance des agents',
  'dir.reports.csat': 'Satisfaction client',
  'dir.reports.rca': 'Analyse des causes racines',
  'dir.reports.descVolume': 'Voyez d’où viennent les tickets et comment ils progressent dans leur cycle de vie.',
  'dir.reports.descSla': 'Suivez les objectifs de réponse et de résolution sur l’ensemble du support accessible.',
  'dir.reports.descAgents': 'Comparez la charge, les résultats, les réponses et les temps de traitement moyens par agent.',
  'dir.reports.descCsat': 'Lisez le ressenti des clients sans confondre volume de réponses et taux de satisfaction.',
  'dir.reports.descRca': 'Trouvez les causes racines standardisées à l’origine de la demande de tickets.',
  'dir.reports.noPayload': 'Aucune donnée de rapport n’a été renvoyée pour cette période.',
  'dir.reports.refresh': 'Actualiser',
  'dir.reports.report': 'Rapport',
  'dir.reports.from': 'Du',
  'dir.reports.to': 'Au',
  'dir.reports.maxRange': 'Plage maximale : 90 jours · le périmètre suit les autorisations de votre compte.',
  'dir.reports.unclassified': 'Non classé',
  'dir.reports.ticketsInPeriod': 'Tickets de la période',
  'dir.reports.ticketsInPeriodDetail': 'Tickets accessibles renvoyés par le rapport',
  'dir.reports.created': 'Créés',
  'dir.reports.createdDetail': 'Sur l’axe de dates sélectionné',
  'dir.reports.resolved': 'Résolus',
  'dir.reports.resolvedDetail': '{percent} % du volume créé',
  'dir.reports.noCreated': 'Aucun ticket créé',
  'dir.reports.reopened': 'Rouverts',
  'dir.reports.reopenedDetail': 'Événements du cycle de vie, pas des tickets uniques',
  'dir.reports.dailyPulse': 'Pouls quotidien',
  'dir.reports.volumeByDate': 'Volume de tickets par date',
  'dir.reports.volumeByDateDescription': 'Les lignes éparses du backend sont étendues en un axe de dates complet complété par des zéros.',
  'dir.reports.createdTickets': 'Tickets créés',
  'dir.reports.createdVolumeAria': 'Volume de tickets créés par date',
  'dir.reports.lifecycle': 'Cycle de vie',
  'dir.reports.lifecycleTitle': 'Créés, résolus, rouverts',
  'dir.reports.lifecycleDescription': 'Une vue à trois courbes du mouvement dans le cycle de vie des tickets.',
  'dir.reports.lifecycleAria': 'Événements du cycle de vie des tickets par date',
  'dir.reports.dimensions': 'Dimensions',
  'dir.reports.whereConcentrated': 'Où le volume est concentré',
  'dir.reports.topEight': 'Les huit premiers segments affichés par panneau',
  'dir.reports.status': 'Statut',
  'dir.reports.statusDescription': 'Statut actuel du ticket',
  'dir.reports.priority': 'Priorité',
  'dir.reports.priorityDescription': 'Répartition des priorités des tickets',
  'dir.reports.group': 'Groupe',
  'dir.reports.groupDescription': 'Groupes de routage',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Responsabilité attribuée',
  'dir.reports.product': 'Produit',
  'dir.reports.productDescription': 'Répartition par produit',
  'dir.reports.country': 'Pays',
  'dir.reports.countryDescription': 'À partir des champs de pays standardisés',
  'dir.reports.noRecords': 'Aucun enregistrement pour cette période.',
  'dir.reports.slaSummary': '{rate} · {met} sur {total} respectés',
  'dir.reports.noSlaSegments': 'Aucun segment SLA pour le moment',
  'dir.reports.noSlaSegmentsDescription': 'Il n’existe aucun enregistrement SLA applicable pour cette dimension sur la période sélectionnée.',
  'dir.reports.segment': 'Segment',
  'dir.reports.firstResponse': 'Première réponse',
  'dir.reports.resolution': 'Résolution',
  'dir.reports.avgFirstResponse': 'Première réponse moy.',
  'dir.reports.avgResolution': 'Résolution moy.',
  'dir.reports.fromTicketMetric': 'Depuis TicketMetric',
  'dir.reports.slaLens': 'Vue SLA',
  'dir.reports.performanceBySegment': 'Performance par segment',
  'dir.reports.slaRatesNote': 'Les taux n’utilisent que les enregistrements ayant un objectif SLA applicable. Les durées sont des temps écoulés moyens.',
  'dir.reports.slaDimensionAria': 'Dimension de ventilation SLA',
  'dir.reports.rosterSignal': 'Signal de l’équipe',
  'dir.reports.agentPerformance': 'Performance des agents',
  'dir.reports.agentPerformanceDescription': 'Tous les agents actifs sont inclus, y compris ceux sans activité.',
  'dir.reports.filterAgentsAria': 'Filtrer les agents',
  'dir.reports.filterAgentsPlaceholder': 'Filtrer par agent ou e-mail',
  'dir.reports.matchingAgents': '{count} agents correspondants',
  'dir.reports.activeAgents': '{count} agents actifs',
  'dir.reports.sortedBy': 'trié par {key} {direction}',
  'dir.reports.asc': 'croissant',
  'dir.reports.desc': 'décroissant',
  'dir.reports.noAgentsMatch': 'Aucun agent ne correspond à ce filtre',
  'dir.reports.assigned': 'Attribués',
  'dir.reports.replies': 'Réponses',
  'dir.reports.csatScore': 'Score CSAT',
  'dir.reports.csatScoreDetail': 'Notes de 4 ou 5',
  'dir.reports.averageRating': 'Note moyenne',
  'dir.reports.averageRatingDetail': 'Sur les enquêtes notées',
  'dir.reports.ratedSurveys': 'Enquêtes notées',
  'dir.reports.ratedSurveysDetail': 'Sur la période sélectionnée',
  'dir.reports.satisfied': 'Satisfaits',
  'dir.reports.satisfiedDetail': 'Réponses positives',
  'dir.reports.responseTrend': 'Tendance des réponses',
  'dir.reports.surveyVolume': 'Volume d’enquêtes par date',
  'dir.reports.surveyVolumeDescription': 'Le backend renvoie le nombre de réponses par date ; ce n’est pas un score quotidien. Les 100 dernières réponses sont échantillonnées ci-dessous.',
  'dir.reports.surveyResponses': 'Réponses aux enquêtes',
  'dir.reports.surveyVolumeAria': 'Volume de réponses aux enquêtes CSAT par date',
  'dir.reports.responsesByGroup': 'Réponses par groupe',
  'dir.reports.responsesByGroupDescription': 'Nombre de réponses aux enquêtes, pas un taux de satisfaction du groupe',
  'dir.reports.responsesByAgent': 'Réponses par agent',
  'dir.reports.responsesByAgentDescription': 'Nombre de réponses aux enquêtes, pas un taux de satisfaction de l’agent',
  'dir.reports.customerVoice': 'Voix du client',
  'dir.reports.latestSurveys': 'Dernières réponses aux enquêtes',
  'dir.reports.boundedSample': 'Échantillon limité · {count} sur 100 max',
  'dir.reports.latestSurveysNote': 'Réponses les plus récentes renvoyées par l’API de reporting. Utilisez ce tableau pour une lecture rapide, pas pour un export complet.',
  'dir.reports.noSurveys': 'Aucune réponse aux enquêtes',
  'dir.reports.noSurveysDescription': 'Les réponses CSAT apparaîtront ici dès que les clients noteront un ticket résolu.',
  'dir.reports.rating': 'Note',
  'dir.reports.comment': 'Commentaire',
  'dir.reports.received': 'Reçu',
  'dir.reports.ratingOutOf': '{rating} sur 5',
  'dir.reports.noComment': 'Aucun commentaire',
  'dir.reports.rcaEyebrow': 'Analyse des causes racines',
  'dir.reports.rcaTitle': 'Pourquoi des tickets sont créés',
  'dir.reports.rcaDescription': 'La catégorie et la sous-catégorie sont des agrégats indépendants issus des champs personnalisés standardisés des tickets.',
  'dir.reports.rcaDimensionAria': 'Dimension RCA',
  'dir.reports.category': 'Catégorie',
  'dir.reports.subcategory': 'Sous-catégorie',
  'dir.reports.rcaEmpty': 'Aucune valeur de cause racine n’a été enregistrée pour cette période.',
  'dir.kb.articleLoadError': 'Impossible de charger l’article.',
  'dir.kb.articleNotFound': 'Article introuvable.',
  'dir.kb.retry': 'Réessayer',
  'dir.kb.title': 'Base de connaissances',
  'dir.kb.breadcrumb': 'Base de connaissances',
  'dir.kb.description': '{articles} articles dans {folders} dossiers',
  'dir.kb.newArticle': 'Nouvel article',
  'dir.kb.editArticle': 'Modifier l’article',
  'dir.kb.sectionsAria': 'Sections de la base de connaissances',
  'dir.kb.tabArticles': 'Articles',
  'dir.kb.tabStructure': 'Catégories et dossiers',
  'dir.kb.folderFilterAria': 'Filtre de dossier',
  'dir.kb.allArticles': 'Tous les articles ({count})',
  'dir.kb.writeFirst': 'Rédigez votre premier article',
  'dir.kb.writeFirstDescription': 'Utilisez Nouvel article pour ajouter du contenu à ce dossier.',
  'dir.kb.byAuthor': 'par {name}',
  'dir.kb.views': '{count} vues',
  'dir.kb.published': 'Publié',
  'dir.kb.draft': 'Brouillon',
  'dir.kb.publish': 'Publier',
  'dir.kb.unpublish': 'Dépublier',
  'dir.kb.noFolders': 'Aucun dossier dans cette catégorie',
  'dir.kb.noFoldersDescription': 'Ajoutez un dossier pour commencer à regrouper les articles.',
  'dir.kb.articlesCount': '{count} articles',
  'dir.kb.fieldTitle': 'Titre',
  'dir.kb.folder': 'Dossier',
  'dir.kb.selectFolder': 'Sélectionner un dossier',
  'dir.kb.content': 'Contenu',
  'dir.kb.contentPlaceholder': 'Rédigez le contenu de votre article...',
  'dir.kb.tags': 'Étiquettes (séparées par des virgules)',
  'dir.kb.attachments': 'Pièces jointes',
  'dir.kb.download': 'Télécharger',
  'dir.kb.downloadFile': 'Télécharger {name}',
  'dir.kb.remove': 'Retirer',
  'dir.kb.removeFile': 'Retirer {name}',
  'dir.kb.noAttachments': 'Aucune pièce jointe pour le moment.',
  'dir.kb.uploadAria': 'Téléverser une pièce jointe',
  'dir.kb.uploading': 'Téléversement...',
  'dir.kb.addFile': 'Ajouter un fichier',
  'dir.kb.confirmDeleteTitle': 'Supprimer l’article ?',
  'dir.kb.confirmDeleteDescription': 'Cet article publié ou brouillon sera supprimé définitivement.',
  'dir.kb.confirmDeleteLabel': 'Supprimer l’article',
  'dir.kb.confirmRemoveTitle': 'Retirer la pièce jointe ?',
  'dir.kb.confirmRemoveDescription': 'Le fichier sera retiré définitivement de cet article.',
  'dir.kb.confirmRemoveLabel': 'Retirer la pièce jointe',
  'dir.reports.rangeInvalid': 'Choisissez des dates de début et de fin valides.',
  'dir.reports.rangeOrder': 'La date de fin doit être égale ou postérieure à la date de début.',
  'dir.reports.rangeMax': 'Les rapports prennent en charge une plage de dates maximale de 90 jours.',

  'adm.active': 'Actif',
  'adm.auto.action.add_tag': 'ajouter une étiquette',
  'adm.auto.action.assign_agent': 'attribuer un agent',
  'adm.auto.action.assign_group': 'attribuer un groupe',
  'adm.auto.action.send_email': 'envoyer un e-mail',
  'adm.auto.action.send_notification': 'envoyer une notification',
  'adm.auto.action.set_priority': 'définir la priorité',
  'adm.auto.action.set_status': 'définir le statut',
  'adm.auto.actions': 'Actions',
  'adm.auto.addAction': '+ Ajouter une action',
  'adm.auto.addCondition': '+ Ajouter une condition',
  'adm.auto.addRule': 'Ajouter une règle',
  'adm.auto.colApplied': 'Actions appliquées',
  'adm.auto.colDate': 'Date',
  'adm.auto.colMatched': 'Correspondance',
  'adm.auto.colSubject': 'Objet',
  'adm.auto.colTicket': 'Ticket',
  'adm.auto.conditions': 'Conditions',
  'adm.auto.confirmDesc': 'Cette règle cessera de s’exécuter immédiatement et ne pourra pas être restaurée.',
  'adm.auto.confirmLabel': 'Supprimer la règle',
  'adm.auto.confirmTitle': 'Supprimer la règle d’automatisation ?',
  'adm.auto.countMany': '{count} règles d’automatisation',
  'adm.auto.countOne': '{count} règle d’automatisation',
  'adm.auto.create': 'Créer',
  'adm.auto.createFirst': 'Créez votre première règle d’automatisation',
  'adm.auto.createFirstDesc': 'Utilisez Ajouter une règle pour acheminer, prioriser ou notifier automatiquement.',
  'adm.auto.deleteFailed': 'Échec de la suppression',
  'adm.auto.description': 'Les règles s’exécutent séquentiellement selon leur position. Les conditions d’une règle sont combinées par ET.',
  'adm.auto.editRule': 'Modifier la règle d’automatisation',
  'adm.auto.execFailed': 'Échec du chargement des exécutions',
  'adm.auto.field.assigneeId': 'responsable',
  'adm.auto.field.companyId': 'entreprise',
  'adm.auto.field.groupId': 'groupe',
  'adm.auto.field.priority': 'priorité',
  'adm.auto.field.requesterId': 'demandeur',
  'adm.auto.field.source': 'source',
  'adm.auto.field.status': 'statut',
  'adm.auto.field.subject': 'objet',
  'adm.auto.field.ticketTypeId': 'type de ticket',
  'adm.auto.hits': 'Déclenchements',
  'adm.auto.loadFailed': 'Échec du chargement des règles d’automatisation',
  'adm.auto.log': 'Journal',
  'adm.auto.logTitle': 'Journal d’exécution — {name}',
  'adm.auto.moveDown': 'Descendre',
  'adm.auto.moveUp': 'Monter',
  'adm.auto.newRule': 'Nouvelle règle d’automatisation',
  'adm.auto.no': 'Non',
  'adm.auto.noRuns': 'Aucune exécution enregistrée pour le moment',
  'adm.auto.noRunsDesc': 'Les exécutions apparaissent ici dès la première fois que cette règle correspond à un ticket.',
  'adm.auto.op.contains': 'contient',
  'adm.auto.op.ends_with': 'se termine par',
  'adm.auto.op.greater_than': 'supérieur à',
  'adm.auto.op.in': 'dans',
  'adm.auto.op.is': 'est',
  'adm.auto.op.is_empty': 'est vide',
  'adm.auto.op.is_not': 'n’est pas',
  'adm.auto.op.is_not_empty': 'n’est pas vide',
  'adm.auto.op.less_than': 'inférieur à',
  'adm.auto.op.not_contains': 'ne contient pas',
  'adm.auto.op.not_in': 'pas dans',
  'adm.auto.op.starts_with': 'commence par',
  'adm.auto.reorderFailed': 'Échec de la réorganisation',
  'adm.auto.saveFailed': 'Échec de l’enregistrement',
  'adm.auto.stopProcessing': 'Arrêter le traitement des règles suivantes',
  'adm.auto.title': 'Règles d’automatisation',
  'adm.auto.toggleFailed': 'Échec du basculement',
  'adm.auto.trigger': 'Déclencheur *',
  'adm.auto.trigger.ticket_creation': 'Création de ticket',
  'adm.auto.trigger.ticket_update': 'Mise à jour de ticket',
  'adm.auto.trigger.time_trigger': 'Basé sur le temps',
  'adm.auto.triggerCol': 'Déclencheur',
  'adm.auto.valuePlaceholder': 'Valeur',
  'adm.auto.yes': 'Oui',
  'adm.close': 'Fermer',
  'adm.deleting': 'Suppression...',
  'adm.description': 'Description',
  'adm.descriptionLabel': 'Description',
  'adm.edit': 'Modifier',
  'adm.email.addChannel': 'Ajouter un canal',
  'adm.email.addTitle': 'Ajouter un canal e-mail',
  'adm.email.colEmail': 'E-mail',
  'adm.email.colReplyTo': 'Répondre à',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Ce canal ne sera plus disponible pour le courrier de support.',
  'adm.email.confirmLabel': 'Supprimer le canal',
  'adm.email.confirmTitle': 'Supprimer le canal e-mail ?',
  'adm.email.countMany': '{count} canaux e-mail',
  'adm.email.countOne': '{count} canal e-mail',
  'adm.email.create': 'Créer',
  'adm.email.createFirst': 'Ajoutez votre premier canal e-mail',
  'adm.email.createFirstDesc': 'Utilisez Ajouter un canal pour connecter une adresse de support afin que les réponses arrivent dans ce centre.',
  'adm.email.default': 'Par défaut',
  'adm.email.defaultChannel': 'Canal par défaut',
  'adm.email.deleteFailed': 'Échec de la suppression',
  'adm.email.description': 'Gérez les adresses e-mail entrantes/sortantes, la configuration SMTP et les paramètres de réponse.',
  'adm.email.editTitle': 'Modifier le canal e-mail',
  'adm.email.emailAddress': 'Adresse e-mail *',
  'adm.email.loadFailed': 'Échec du chargement des configurations e-mail',
  'adm.email.outbound': 'SMTP sortant',
  'adm.email.replyTo': 'Adresse de réponse',
  'adm.email.replyToPh': '(par défaut : adresse e-mail)',
  'adm.email.saveFailed': 'Échec de l’enregistrement',
  'adm.email.sesGlobal': 'SES (global)',
  'adm.email.smtpHost': 'Hôte SMTP',
  'adm.email.smtpHostPh': 'ex. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Mot de passe SMTP',
  'adm.email.smtpPort': 'Port SMTP',
  'adm.email.smtpUser': 'Utilisateur SMTP',
  'adm.email.title': 'Canaux e-mail',
  'adm.groups.aboutBody': 'Les membres déterminent quels agents voient par défaut les tickets de ce groupe. Les heures ouvrées régissent le calcul du SLA des tickets acheminés ici, et le contact d’escalade est notifié en plus du responsable lorsqu’un ticket dépasse son SLA.',
  'adm.groups.aboutTitle': 'À propos de ce groupe',
  'adm.groups.accountDefault': 'Par défaut du compte',
  'adm.groups.activeAgentMany': '{count} agents actifs',
  'adm.groups.activeAgentOne': '{count} agent actif',
  'adm.groups.activeAgents': 'Agents actifs',
  'adm.groups.addMember': 'Ajouter un membre',
  'adm.groups.assignment': 'Attribution',
  'adm.groups.autoAssign': 'Attribution automatique',
  'adm.groups.autoAssignNote': 'L’attribution des tickets est toujours manuelle dans ce produit : il n’y a ni répartition circulaire ni routage basé sur la charge. Ce commutateur n’y change rien.',
  'adm.groups.businessHours': 'Heures ouvrées',
  'adm.groups.colGroup': 'Groupe',
  'adm.groups.confirmDesc': 'Les tickets et modèles utilisant ce groupe doivent d’abord être réattribués.',
  'adm.groups.confirmLabel': 'Supprimer le groupe',
  'adm.groups.confirmTitle': 'Supprimer « {name} » ?',
  'adm.groups.createFirst': 'Créez votre premier groupe',
  'adm.groups.defaultHours': 'Heures par défaut',
  'adm.groups.editAria': 'Modifier {name}',
  'adm.groups.editGroup': 'Modifier le groupe',
  'adm.groups.escalateHelp': 'Ajouté comme destinataire de notification lorsqu’un ticket de ce groupe dépasse son SLA.',
  'adm.groups.escalateTo': 'Escalader à',
  'adm.groups.escalatesTo': 'Escalade à',
  'adm.groups.escalatesToName': 'Escalade à {name}',
  'adm.groups.escalationBody': 'Lorsqu’un ticket de ce groupe dépasse son SLA, le contact d’escalade est ajouté comme destinataire de notification avec le responsable et les membres du groupe.',
  'adm.groups.escalationTitle': 'Contact d’escalade',
  'adm.groups.hoursHelp': 'Utilisé pour les calculs SLA des tickets de ce groupe.',
  'adm.groups.manageAgents': 'Gérer les agents',
  'adm.groups.manageHours': 'Gérer les heures ouvrées',
  'adm.groups.manual': 'Manuelle',
  'adm.groups.manualBody': 'L’attribution est manuelle dans ce produit : il n’y a ni attribution automatique circulaire ni basée sur la charge. Le commutateur « Attribution automatique » d’un groupe détermine seulement si les nouveaux tickets de ce groupe restent non attribués par défaut ou reviennent à une règle de routage existante ; les agents prennent et transmettent toujours eux-mêmes les tickets.',
  'adm.groups.manualTitle': 'Attribution manuelle',
  'adm.groups.memberMany': '{count} membres',
  'adm.groups.memberOne': '{count} membre',
  'adm.groups.members': 'Membres',
  'adm.groups.newGroup': 'Nouveau groupe',
  'adm.groups.noEscalation': 'Aucun contact d’escalade',
  'adm.groups.noMatch': 'Aucun groupe ne correspond à cette recherche',
  'adm.groups.noMembers': 'Aucun membre pour le moment',
  'adm.groups.noMembersDesc': 'Choisissez un agent actif ci-dessus et sélectionnez Ajouter un membre.',
  'adm.groups.remove': 'Retirer',
  'adm.groups.routing': 'Routage',
  'adm.groups.routingMethod': 'Méthode de routage',
  'adm.groups.saved': 'Groupe enregistré.',
  'adm.groups.searchAria': 'Rechercher des groupes',
  'adm.groups.searchPlaceholder': 'Rechercher par nom',
  'adm.groups.selectActiveAgent': 'Sélectionner un agent actif',
  'adm.groups.showing': 'Affichage de {start}-{end} sur {total}',
  'adm.groups.subtitle': 'Les groupes contrôlent le routage et la visibilité des tickets. Ajoutez des agents comme membres et choisissez des heures ouvrées et un contact d’escalade pour chaque groupe.',
  'adm.groups.title': 'Groupes',
  'adm.groups.tryDifferent': 'Essayez un autre nom de groupe.',
  'adm.groups.unassigned': 'Non attribué',
  'adm.groups.useNew': 'Utilisez Nouveau groupe pour acheminer les tickets vers un ensemble d’agents.',
  'adm.groups.zero': '0 groupe',
  'adm.inactive': 'Inactif',
  'adm.jira.accepted': 'Connexion acceptée',
  'adm.jira.accountEmail': 'E-mail du compte Jira',
  'adm.jira.accountEmailLabel': 'E-mail du compte',
  'adm.jira.activeConn': 'Connexion active',
  'adm.jira.addConnection': 'Ajouter une connexion',
  'adm.jira.addTitle': 'Ajouter une connexion Jira',
  'adm.jira.added': 'Connexion Jira ajoutée',
  'adm.jira.apiToken': 'Jeton API',
  'adm.jira.clearSecret': 'Effacer le secret de webhook enregistré',
  'adm.jira.confirmDesc': 'Cela supprime la connexion enregistrée et ses liens de tickets. Les tickets Jira ne sont pas supprimés.',
  'adm.jira.confirmLabel': 'Supprimer la connexion',
  'adm.jira.confirmTitle': 'Supprimer {name} ?',
  'adm.jira.connName': 'Nom de la connexion',
  'adm.jira.connNamePh': 'Jira Ingénierie',
  'adm.jira.connectedAs': 'Connecté en tant que {name}',
  'adm.jira.connectionDesk': 'Poste de connexion',
  'adm.jira.default': 'Par défaut',
  'adm.jira.defaultConn': 'Connexion par défaut',
  'adm.jira.defaultIssueType': 'Type de ticket par défaut',
  'adm.jira.defaultProjectKey': 'Clé de projet par défaut',
  'adm.jira.defaults': 'Valeurs par défaut',
  'adm.jira.description': 'Connectez les sites Jira du compte pour que les agents puissent lier des tickets et garder les statuts synchronisés.',
  'adm.jira.editTitle': 'Modifier la connexion Jira',
  'adm.jira.footer': 'Créez le webhook Jira avec le point de terminaison indiqué ci-dessus, abonnez-vous aux événements de mise à jour de tickets et utilisez le même secret de webhook que celui configuré ici.',
  'adm.jira.heading': 'Gardez le support et l’ingénierie dans la même boucle',
  'adm.jira.intro': 'Les identifiants sont stockés chiffrés sur le serveur et ne sont jamais renvoyés à cet écran. Configurez un secret de webhook lorsque Jira doit renvoyer les changements de statut à SuzukiDesk.',
  'adm.jira.no': 'Non',
  'adm.jira.noConns': 'Aucune connexion Jira pour le moment',
  'adm.jira.noConnsDesc': 'Ajoutez une connexion pour rendre les actions Jira disponibles depuis le détail du ticket.',
  'adm.jira.noProject': 'Aucun projet',
  'adm.jira.pasteToken': 'Collez le jeton',
  'adm.jira.requestFailed': 'La requête Jira a échoué. Veuillez réessayer.',
  'adm.jira.savedToast': 'Connexion Jira enregistrée',
  'adm.jira.secretConfigured': 'Secret configuré : {value}',
  'adm.jira.secretHint': 'Utilisez le même secret lors de la création du webhook Jira.',
  'adm.jira.secretOptional': 'Facultatif, 16 caractères minimum',
  'adm.jira.siteUrl': 'URL du site Jira',
  'adm.jira.siteUrlHint': 'N’incluez pas d’identifiants dans l’URL.',
  'adm.jira.syncFromJira': 'Statut Jira vers le ticket',
  'adm.jira.syncSnapshot': 'Instantané du ticket lié',
  'adm.jira.syncToJira': 'Statut du ticket vers Jira',
  'adm.jira.testConnection': 'Tester la connexion',
  'adm.jira.testFailed': 'Échec du test de connexion',
  'adm.jira.title': 'Intégration Jira',
  'adm.jira.tokenHintEdit': 'Laissez vide pour conserver le jeton actuel.',
  'adm.jira.tokenHintNew': 'Stocké chiffré ; il ne sera plus affiché.',
  'adm.jira.tokenMissing': 'Jeton API manquant',
  'adm.jira.tokenStored': 'Jeton API enregistré',
  'adm.jira.unchanged': '(inchangé si vide)',
  'adm.jira.verified': 'Connexion Jira vérifiée',
  'adm.jira.webhookEndpoint': 'Point de terminaison du webhook Jira',
  'adm.jira.webhookSecret': 'Secret du webhook',
  'adm.jira.whatSyncs': 'Ce qui est synchronisé',
  'adm.jira.yes': 'Oui',
  'adm.nameRequired': 'Nom *',
  'adm.nextPage': 'Page suivante',
  'adm.notif.aud.all': 'Partagé',
  'adm.notif.aud.customer': 'Client',
  'adm.notif.aud.internal': 'Interne',
  'adm.notif.audEmail': 'E-mail {audience}',
  'adm.notif.body': 'Corps',
  'adm.notif.description': 'Personnalisez chaque public de notification sans envoyer les clients dans l’espace de travail interne.',
  'adm.notif.discardDesc': 'Vos modifications non enregistrées de ce modèle de notification seront perdues si vous changez de modèle.',
  'adm.notif.discardLabel': 'Abandonner les modifications',
  'adm.notif.discardTitle': 'Abandonner les modifications non enregistrées ?',
  'adm.notif.discarded': 'Modifications non enregistrées abandonnées.',
  'adm.notif.event.automation_notification': 'Notification d’automatisation',
  'adm.notif.event.group_member_added': 'Ajouté au groupe',
  'adm.notif.event.mention': 'Mention',
  'adm.notif.event.pending_input': 'En attente de saisie',
  'adm.notif.event.sla_breach': 'Violation SLA',
  'adm.notif.event.sla_escalation': 'Escalade SLA',
  'adm.notif.event.sla_warning': 'Alerte SLA',
  'adm.notif.event.ticket_assigned': 'Ticket attribué',
  'adm.notif.event.ticket_created': 'Ticket créé',
  'adm.notif.event.ticket_first_response': 'Première réponse',
  'adm.notif.event.ticket_group_assigned': 'Ticket attribué au groupe',
  'adm.notif.event.ticket_note': 'Note privée',
  'adm.notif.event.ticket_public_note': 'Note publique',
  'adm.notif.event.ticket_reply': 'Réponse au ticket',
  'adm.notif.event.ticket_resolved': 'Ticket résolu',
  'adm.notif.events': 'Événements',
  'adm.notif.eventsHelp': 'Choisissez un événement et un public destinataire.',
  'adm.notif.insertVar': 'Insérer {variable}',
  'adm.notif.linkNoteAgent': 'La variable de lien adaptée au public {variable} ouvre l’espace de travail des agents pour cet e-mail.',
  'adm.notif.linkNoteCustomer': 'La variable de lien adaptée au public {variable} ouvre le portail client pour cet e-mail.',
  'adm.notif.off': 'désactivé',
  'adm.notif.preview': 'Aperçu',
  'adm.notif.previewNotice': 'Aperçu généré avec des données d’exemple.',
  'adm.notif.rendering': 'Génération…',
  'adm.notif.route.all': 'Utilise le lien de ticket adapté au destinataire pour le public de distribution.',
  'adm.notif.route.customer': 'L’action principale ouvre le ticket dans le portail client.',
  'adm.notif.route.internal': 'L’action principale ouvre le ticket dans l’espace de travail des agents.',
  'adm.notif.sampleOnlyAgent': 'Données d’exemple uniquement — l’action principale cible la route de l’espace de travail des agents.',
  'adm.notif.sampleOnlyCustomer': 'Données d’exemple uniquement — l’action principale cible la route du portail client.',
  'adm.notif.saveChanges': 'Enregistrer les modifications',
  'adm.notif.saved': 'Modèle enregistré.',
  'adm.notif.savedBtn': 'Enregistré',
  'adm.notif.selectEvent': 'Sélectionnez un événement pour modifier son modèle',
  'adm.notif.selectEventDesc': 'Choisissez un événement de notification à gauche pour modifier son objet et son corps.',
  'adm.notif.sendTest': 'Envoyer un e-mail de test',
  'adm.notif.sending': 'Envoi…',
  'adm.notif.subject': 'Objet',
  'adm.notif.testQueued': 'E-mail de test mis en file d’attente pour {email}.',
  'adm.notif.title': 'Modèles de notification',
  'adm.notif.urlVarTitle': 'Variable de lien adaptée au public',
  'adm.notif.useTemplate': 'Utiliser ce modèle pour ce public',
  'adm.notif.useTemplateHelp': 'Le désactiver utilise la notification de secours sûre.',
  'adm.notif.variables': 'Variables',
  'adm.notif.variablesHelp': 'Cliquez pour ajouter au corps du message',
  'adm.pagination': 'Pagination',
  'adm.perm.cap.admin.label': 'Accéder à la console d’administration',
  'adm.perm.cap.assign.label': 'Attribuer un ticket',
  'adm.perm.cap.close.label': 'Fermer un ticket',
  'adm.perm.cap.conversation_delete.label': 'Supprimer une réponse ou une note publiée',
  'adm.perm.cap.conversation_edit.label': 'Modifier une réponse ou une note publiée',
  'adm.perm.cap.create.label': 'Créer un ticket',
  'adm.perm.cap.delete.label': 'Supprimer un ticket',
  'adm.perm.cap.edit.label': 'Modifier les propriétés du ticket',
  'adm.perm.cap.export.label': 'Exporter des tickets',
  'adm.perm.cap.field_admin.label': 'Champs du ticket',
  'adm.perm.cap.form_admin.label': 'Formulaires de ticket',
  'adm.perm.cap.forward.label': 'Transférer un ticket',
  'adm.perm.cap.jira_link.label': 'Lier et gérer les tickets Jira',
  'adm.perm.cap.kb.label': 'Accéder à la base de connaissances',
  'adm.perm.cap.manage_agents.label': 'Agents',
  'adm.perm.cap.manage_api_keys.label': 'Clés API',
  'adm.perm.cap.manage_automations.label': 'Automatisations',
  'adm.perm.cap.manage_canned_responses.label': 'Réponses enregistrées',
  'adm.perm.cap.manage_email_config.label': 'E-mail',
  'adm.perm.cap.manage_groups.label': 'Groupes',
  'adm.perm.cap.manage_jira.label': 'Intégration Jira',
  'adm.perm.cap.manage_kb.label': 'Base de connaissances',
  'adm.perm.cap.manage_notification_templates.label': 'Modèles de notification',
  'adm.perm.cap.manage_roles.label': 'Rôles',
  'adm.perm.cap.manage_tags.label': 'Étiquettes',
  'adm.perm.cap.note.label': 'Ajouter ou modifier des notes privées',
  'adm.perm.cap.reassign.label': 'Réattribuer un ticket déjà détenu par quelqu’un d’autre',
  'adm.perm.cap.reopen.label': 'Rouvrir un ticket résolu ou fermé',
  'adm.perm.cap.reply.label': 'Répondre publiquement au client',
  'adm.perm.cap.report_access.label': 'Consulter les rapports et tableaux de bord',
  'adm.perm.cap.reports.label': 'Accéder au module de rapports',
  'adm.perm.cap.resolve.label': 'Résoudre un ticket',
  'adm.perm.cap.settings_admin.label': 'Ouvrir la section Paramètres (requis pour voir l’élément de navigation Paramètres et sa page d’index ; l’accès à chaque page ci-dessous reste contrôlé indépendamment)',
  'adm.perm.cap.sla_admin.label': 'Politiques SLA et heures ouvrées',
  'adm.perm.cap.sla_edit.desc': 'Distinct de l’autorisation Paramètres > Politiques SLA ci-dessous — celle-ci ne couvre que la modification des échéances d’un ticket individuel.',
  'adm.perm.cap.sla_edit.label': 'Forcer manuellement les échéances SLA d’un ticket',
  'adm.perm.cap.tag.label': 'Gérer les étiquettes de ticket',
  'adm.perm.cap.thread_start.label': 'Démarrer un fil privé sur une entrée de conversation',
  'adm.perm.cap.tickets.label': 'Accéder à l’espace de travail des tickets',
  'adm.perm.cap.view.label': 'Consulter les tickets du périmètre',
  'adm.perm.cat.administration.desc': 'Accès à la console d’administration et à ses écrans de configuration.',
  'adm.perm.cat.administration.label': 'Administration',
  'adm.perm.cat.knowledge.desc': 'Lecture et utilisation du contenu de la base de connaissances pendant le traitement d’un ticket.',
  'adm.perm.cat.knowledge.label': 'Base de connaissances',
  'adm.perm.cat.reporting.desc': 'Rapports opérationnels et tableaux de bord.',
  'adm.perm.cat.reporting.label': 'Rapports',
  'adm.perm.cat.settings-pages.desc': 'Accordez l’accès à chaque écran de Paramètres individuellement. Rien n’est visible tant que ce n’est pas explicitement coché ici.',
  'adm.perm.cat.settings-pages.label': 'Pages de paramètres',
  'adm.perm.cat.tickets.desc': 'Ce qu’un agent peut faire dans l’espace de travail des tickets.',
  'adm.perm.cat.tickets.label': 'Tickets',
  'adm.previousPage': 'Page précédente',
  'adm.refresh': 'Actualiser',
  'adm.roleType.administrator': 'Administrateur',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Collaborateur',
  'adm.roleType.customer': 'Client',
  'adm.roleType.super_admin': 'Super administrateur',
  'adm.roleType.supervisor': 'Superviseur',
  'adm.roles.activeHelp': 'Actif - les rôles inactifs ne peuvent pas être attribués aux agents',
  'adm.roles.agentCan': 'L’agent peut',
  'adm.roles.agentType': 'Type d’agent',
  'adm.roles.agentsAssignedNote': 'Les agents reçoivent ce rôle depuis l’écran Agents.',
  'adm.roles.agentsCount': '{count} agents',
  'adm.roles.agentsLabel': 'Agents',
  'adm.roles.agentsManage': '{count} agents - Gérer',
  'adm.roles.builtIn': '(Intégré)',
  'adm.roles.builtInNote': 'Ce rôle est intégré. Il peut être renommé et désactivé, mais pas supprimé.',
  'adm.roles.builtInTitle': 'Rôle intégré : modifiable et désactivable, mais non supprimable',
  'adm.roles.categoriesAria': 'Catégories d’autorisations',
  'adm.roles.confirmDesc': 'Les agents ayant ce rôle auront besoin d’un autre rôle avant qu’il puisse être supprimé.',
  'adm.roles.confirmLabel': 'Supprimer le rôle',
  'adm.roles.createFirst': 'Créez votre premier rôle',
  'adm.roles.createFirstDesc': 'Utilisez Nouveau rôle pour définir les capacités que les agents doivent obtenir.',
  'adm.roles.editRole': 'Modifier le rôle',
  'adm.roles.granted': '{count} accordée(s)',
  'adm.roles.heading': 'Rôles des agents',
  'adm.roles.inactive': 'Inactif',
  'adm.roles.newRole': 'Nouveau rôle',
  'adm.roles.noAgent': 'Aucun agent',
  'adm.roles.notEnforced': '(pas encore appliqué)',
  'adm.roles.notEnforcedTitle': 'Enregistré sur le rôle mais pas encore contrôlé à l’exécution',
  'adm.roles.permissions': 'Autorisations',
  'adm.roles.saved': 'Rôle enregistré.',
  'adm.roles.scopeBody': 'Les capacités se combinent avec le périmètre au niveau des lignes (tous / groupe / attribués / propres), de sorte qu’un agent n’agit que sur les tickets qu’il peut déjà voir.',
  'adm.roles.scopeTitle': 'Le périmètre s’applique toujours',
  'adm.roles.scrollTo': 'Aller à',
  'adm.roles.status': 'Statut',
  'adm.roles.subtitle': 'Définissez et restreignez des niveaux d’accès et de privilèges précis pour les agents.',
  'adm.roles.title': 'Rôles',
  'adm.roles.typeLocked': 'Le type d’agent ne peut plus être modifié une fois le rôle enregistré.',
  'adm.roles.understandingBody1': 'Les rôles déterminent ce qu’un agent peut faire. Créez un rôle, cochez les capacités à accorder, puis attribuez-le aux agents depuis l’écran Agents.',
  'adm.roles.understandingBody2': 'Les rôles intégrés peuvent être renommés et désactivés mais jamais supprimés. Un rôle auquel des agents sont encore attribués ne peut pas non plus être supprimé : déplacez d’abord ces agents.',
  'adm.roles.understandingTitle': 'Comprendre les rôles',
  'adm.saveChanges': 'Enregistrer les modifications',
  'adm.settings.add': 'Ajouter {name}',
  'adm.settings.back': 'Retour aux paramètres',
  'adm.settings.cannedDesc': 'Réponses du compte disponibles pour vous pendant le traitement d’un ticket.',
  'adm.settings.cannedEmpty': 'Aucune réponse enregistrée pour le moment',
  'adm.settings.cannedEmptyDesc': 'Demandez à un administrateur d’ajouter des réponses partagées que votre équipe pourra réutiliser sur un ticket.',
  'adm.settings.cannedTitle': 'Réponses enregistrées',
  'adm.settings.col.autoAssign': 'Attribution auto',
  'adm.settings.col.color': 'Couleur',
  'adm.settings.col.content': 'Contenu',
  'adm.settings.col.createdAt': 'Créé le',
  'adm.settings.col.description': 'Description',
  'adm.settings.col.email': 'E-mail',
  'adm.settings.col.expiresAt': 'Expire le',
  'adm.settings.col.fieldType': 'Type de champ',
  'adm.settings.col.firstName': 'Prénom',
  'adm.settings.col.folderId': 'ID du dossier',
  'adm.settings.col.hitCount': 'Nombre de hits',
  'adm.settings.col.holidays': 'Jours fériés',
  'adm.settings.col.host': 'Hôte',
  'adm.settings.col.hours': 'Heures',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Actif',
  'adm.settings.col.isBuiltIn': 'Intégré',
  'adm.settings.col.isDefault': 'Par défaut',
  'adm.settings.col.isRequired': 'Obligatoire',
  'adm.settings.col.isShared': 'Partagé',
  'adm.settings.col.isSystem': 'Système',
  'adm.settings.col.key': 'Clé',
  'adm.settings.col.label': 'Libellé',
  'adm.settings.col.language': 'Langue',
  'adm.settings.col.lastName': 'Nom',
  'adm.settings.col.lastUsedAt': 'Dernière utilisation',
  'adm.settings.col.name': 'Nom',
  'adm.settings.col.options': 'Options',
  'adm.settings.col.phone': 'Téléphone',
  'adm.settings.col.port': 'Port',
  'adm.settings.col.position': 'Position',
  'adm.settings.col.prefix': 'Préfixe',
  'adm.settings.col.priority': 'Priorité',
  'adm.settings.col.required': 'Obligatoire',
  'adm.settings.col.role': 'Rôle',
  'adm.settings.col.roleId': 'ID du rôle',
  'adm.settings.col.scopes': 'Périmètres',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Statut',
  'adm.settings.col.stopProcessing': 'Arrêter le traitement',
  'adm.settings.col.timezone': 'Fuseau horaire',
  'adm.settings.col.title': 'Titre',
  'adm.settings.col.trigger': 'Déclencheur',
  'adm.settings.col.type': 'Type',
  'adm.settings.col.updatedAt': 'Mis à jour le',
  'adm.settings.col.usageCount': 'Nombre d’utilisations',
  'adm.settings.col.username': 'Nom d’utilisateur',
  'adm.settings.confirmDesc': 'Cette action est irréversible.',
  'adm.settings.confirmTitle': 'Supprimer {name} ?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Créer',
  'adm.settings.empty': 'Aucun {title} pour le moment',
  'adm.settings.emptyAdd': 'Utilisez le formulaire ci-dessus pour ajouter votre premier élément ({name}).',
  'adm.settings.emptyOther': 'Les entrées apparaissent ici une fois configurées.',
  'adm.settings.homeDesc': 'Configurez les utilisateurs, les workflows de tickets, les niveaux de service et les intégrations.',
  'adm.settings.manage': 'Gérer : {title}.',
  'adm.settings.noPages': 'Aucune page de paramètres disponible',
  'adm.settings.noPagesDesc': 'Demandez à un super administrateur de vous donner accès aux pages de paramètres dont vous avez besoin.',
  'adm.settings.notFound': 'Page de paramètres introuvable',
  'adm.settings.notFoundDesc': 'Choisissez une zone de paramètres pour continuer.',
  'adm.settings.res.agents.field.email': 'E-mail',
  'adm.settings.res.agents.field.firstName': 'Prénom',
  'adm.settings.res.agents.field.lastName': 'Nom',
  'adm.settings.res.agents.field.password': 'Mot de passe temporaire',
  'adm.settings.res.agents.field.roleId': 'ID du rôle',
  'adm.settings.res.agents.one': 'agent',
  'adm.settings.res.agents.title': 'Agents',
  'adm.settings.res.api-keys.field.name': 'Nom de la clé',
  'adm.settings.res.api-keys.one': 'clé API',
  'adm.settings.res.api-keys.title': 'Clés API',
  'adm.settings.res.automations.field.description': 'Description',
  'adm.settings.res.automations.field.name': 'Nom',
  'adm.settings.res.automations.one': 'automatisation',
  'adm.settings.res.automations.title': 'Automatisations',
  'adm.settings.res.business-hours.field.name': 'Nom',
  'adm.settings.res.business-hours.field.timezone': 'Fuseau horaire',
  'adm.settings.res.business-hours.one': 'entrée d’heures ouvrées',
  'adm.settings.res.business-hours.title': 'Heures ouvrées',
  'adm.settings.res.canned-responses.field.content': 'Contenu de la réponse',
  'adm.settings.res.canned-responses.field.title': 'Titre',
  'adm.settings.res.canned-responses.one': 'réponse enregistrée',
  'adm.settings.res.canned-responses.title': 'Réponses enregistrées',
  'adm.settings.res.email.field.host': 'Hôte SMTP',
  'adm.settings.res.email.field.name': 'Nom',
  'adm.settings.res.email.field.port': 'Port SMTP',
  'adm.settings.res.email.field.username': 'Nom d’utilisateur',
  'adm.settings.res.email.one': 'configuration e-mail',
  'adm.settings.res.email.title': 'Configuration e-mail',
  'adm.settings.res.fields.one': 'champ de ticket',
  'adm.settings.res.fields.title': 'Champs du ticket',
  'adm.settings.res.forms.field.label': 'Libellé affiché',
  'adm.settings.res.forms.field.name': 'Nom du champ',
  'adm.settings.res.forms.field.type': 'Type de champ',
  'adm.settings.res.forms.one': 'formulaire ou champ personnalisé',
  'adm.settings.res.forms.title': 'Formulaires et champs personnalisés',
  'adm.settings.res.groups.field.description': 'Description',
  'adm.settings.res.groups.field.name': 'Nom',
  'adm.settings.res.groups.one': 'groupe',
  'adm.settings.res.groups.title': 'Groupes',
  'adm.settings.res.jira.one': 'intégration Jira',
  'adm.settings.res.jira.title': 'Intégration Jira',
  'adm.settings.res.kb.field.content': 'Contenu de l’article',
  'adm.settings.res.kb.field.folderId': 'ID du dossier',
  'adm.settings.res.kb.field.title': 'Titre de l’article',
  'adm.settings.res.kb.one': 'article de la base de connaissances',
  'adm.settings.res.kb.title': 'Administration de la base de connaissances',
  'adm.settings.res.notification-templates.one': 'modèle de notification',
  'adm.settings.res.notification-templates.title': 'Modèles de notification',
  'adm.settings.res.roles.field.description': 'Description',
  'adm.settings.res.roles.field.name': 'Nom',
  'adm.settings.res.roles.field.type': 'Type de rôle',
  'adm.settings.res.roles.one': 'rôle',
  'adm.settings.res.roles.title': 'Rôles',
  'adm.settings.res.sla.field.description': 'Description',
  'adm.settings.res.sla.field.name': 'Nom',
  'adm.settings.res.sla.one': 'politique SLA',
  'adm.settings.res.sla.title': 'Politiques SLA',
  'adm.settings.res.tags.field.name': 'Nom',
  'adm.settings.res.tags.one': 'étiquette',
  'adm.settings.res.tags.title': 'Étiquettes',
  'adm.settings.title': 'Paramètres',
  'adm.status': 'Statut',

  'sla.edit': 'Modifier',
  'sla.active': 'Actif',
  'sla.inactive': 'Inactif',
  'sla.default': 'Par défaut',
  'sla.yes': 'Oui',
  'sla.no': 'Non',
  'sla.description': 'Description',
  'sla.status': 'Statut',
  'sla.notConfigured': 'Non configuré',
  'sla.minutesValue': '{value} minutes',
  'sla.invalidServerValue': 'Valeur serveur non valide',
  'sla.statusSemantics.title': 'Sémantique des statuts de ticket',
  'sla.statusSemantics.description': 'Chaque statut actif a un contrat SLA explicite. Un statut qui met en pause et un statut qui arrête le SLA s’excluent mutuellement.',
  'sla.statusSemantics.conflict': 'Un statut ne peut pas à la fois mettre en pause et arrêter le SLA.',
  'sla.statusSemantics.emptyTitle': 'Aucune définition de statut',
  'sla.statusSemantics.emptyDescription': 'Les définitions de statut apparaîtront ici une fois configurées pour ce compte.',
  'sla.statusSemantics.colPauses': 'Met le SLA en pause',
  'sla.statusSemantics.colStops': 'Arrête le SLA',
  'sla.statusSemantics.pausesAria': '{label} met le SLA en pause',
  'sla.statusSemantics.stopsAria': '{label} arrête le SLA',
  'sla.preview.title': 'Aperçu de ticket en lecture seule',
  'sla.preview.description': 'Exécutez le même évaluateur, limité au compte, que celui des cycles SLA en direct. Cet aperçu n’écrit jamais de politique ni de ticket.',
  'sla.preview.priority': 'Priorité',
  'sla.preview.group': 'Groupe',
  'sla.preview.anyGroup': 'Tous les groupes',
  'sla.preview.company': 'Entreprise',
  'sla.preview.anyCompany': 'Toutes les entreprises',
  'sla.preview.source': 'Source',
  'sla.preview.anySource': 'Toutes les sources',
  'sla.preview.ticketType': 'Type de ticket',
  'sla.preview.anyTicketType': 'Tous les types de ticket',
  'sla.preview.representativeStart': 'Début représentatif',
  'sla.preview.calculating': 'Calcul en cours…',
  'sla.preview.run': 'Lancer l’aperçu',
  'sla.preview.configAttention': 'La configuration nécessite votre attention',
  'sla.preview.selectedPolicy': 'Politique sélectionnée',
  'sla.preview.noPolicy': 'Aucune politique',
  'sla.preview.evaluationOrder': 'Ordre d’évaluation',
  'sla.preview.firstMatching': 'Première politique correspondante',
  'sla.preview.calculationMode': 'Mode de calcul',
  'sla.preview.modeBusinessHours': 'Heures ouvrées',
  'sla.preview.modeBusinessHoursNamed': 'Heures ouvrées · {name}',
  'sla.preview.mode247': 'Temps écoulé 24h/24, 7j/7',
  'sla.preview.modeNone': 'Non calculé',
  'sla.preview.thresholds': 'Seuils indépendants',
  'sla.preview.colMetric': 'Indicateur',
  'sla.preview.colTarget': 'Objectif',
  'sla.preview.colWarning': 'Alerte',
  'sla.preview.colDue': 'Échéance / violation',
  'sla.preview.colEscalation': 'Escalade',
  'sla.preview.colState': 'État',
  'sla.preview.metricFirstResponse': 'Première réponse',
  'sla.preview.metricResolution': 'Résolution',
  'sla.preview.trace': 'Trace d’évaluation de la politique',
  'sla.preview.selected': 'Sélectionnée',
  'sla.preview.matchedAfterSelection': 'Correspondante après la sélection',
  'sla.preview.skipped': 'Ignorée',
  'sla.preview.showTrace': 'Afficher la trace de calcul',
  'sla.state.not_configured': 'non configuré',
  'sla.state.running': 'en cours',
  'sla.state.paused': 'en pause',
  'sla.state.warning': 'alerte',
  'sla.state.breached': 'dépassé',
  'sla.state.met': 'respecté',
  'sla.state.escalated': 'escaladé',
  'sla.state.pending': 'en attente',
  'sla.state.stopped': 'arrêté',
  'sla.state.on_track': 'dans les temps',
  'sla.state.at_risk': 'à risque',
  'sla.list.subtitle': 'Définissez des objectifs de première réponse et de résolution par priorité. Les politiques sont évaluées de haut en bas : la première dont les conditions correspondent à un ticket s’applique.',
  'sla.list.newPolicy': 'Nouvelle politique',
  'sla.list.emptyTitle': 'Créez votre première politique SLA',
  'sla.list.emptyDescription': 'Utilisez Nouvelle politique pour définir des objectifs de première réponse et de résolution par priorité.',
  'sla.list.moveUp': 'Monter',
  'sla.list.moveDown': 'Descendre',
  'sla.list.frShort': 'PR : {value}',
  'sla.list.resolveShort': 'Résolution : {value}',
  'sla.list.escalateShort': 'Escalade : +{value}',
  'sla.list.deactivate': 'Désactiver',
  'sla.list.activate': 'Activer',
  'sla.list.setDefault': 'Définir par défaut',
  'sla.list.duplicate': 'Dupliquer',
  'sla.list.deleteTitle': 'Supprimer « {name} » ?',
  'sla.list.deleteDescription': 'Les tickets associés à cette politique utiliseront la prochaine politique SLA disponible.',
  'sla.list.deleteConfirm': 'Supprimer la politique',
  'sla.conditions.groups': '{count} groupe(s)',
  'sla.conditions.companies': '{count} entreprise(s)',
  'sla.conditions.sources': 'sources : {list}',
  'sla.conditions.ticketTypes': '{count} type(s) de ticket',
  'sla.conditions.anyOf': 'l’un des',
  'sla.conditions.allOf': 'tous les',
  'sla.conditions.summary': 'Conditions ({mode}) : {parts}',
  'sla.edit.newTitle': 'Nouvelle politique SLA',
  'sla.edit.editTitle': 'Modifier la politique SLA',
  'sla.edit.saved': 'Politique SLA enregistrée.',
  'sla.edit.name': 'Nom',
  'sla.edit.appliesToPriority': 'S’applique à la priorité',
  'sla.edit.evaluationOrder': 'Ordre d’évaluation',
  'sla.edit.evaluationOrderHint': 'Les positions les plus basses sont évaluées en premier pour ce compte.',
  'sla.edit.defaultPolicy': 'Politique par défaut',
  'sla.edit.useAsDefault': 'Utiliser par défaut quand aucune autre politique ne correspond',
  'sla.edit.targets': 'Objectifs SLA',
  'sla.edit.firstResponse': 'Première réponse',
  'sla.edit.resolution': 'Résolution',
  'sla.edit.autoAt75': 'Automatique à 75 %',
  'sla.edit.enabledAfter': 'Activé après {value}',
  'sla.edit.clearEscalation': 'Supprimer explicitement la cible d’escalade',
  'sla.edit.clearEscalationHint': 'Envoie null ; si la case reste décochée, le champ est omis et la valeur enregistrée est conservée.',
  'sla.edit.firstResponseMinutes': 'Première réponse (minutes)',
  'sla.edit.resolutionMinutes': 'Résolution (minutes)',
  'sla.edit.escalateAfter': 'Escalader après (minutes après l’échéance de résolution)',
  'sla.edit.notSet': 'Non défini',
  'sla.edit.remindersNote': 'Les rappels se déclenchent automatiquement à 75 % des fenêtres de première réponse et de résolution. L’escalade notifie l’agent d’escalade du groupe du ticket (défini sur le groupe) une fois l’objectif de résolution manqué du nombre de minutes configuré.',
  'sla.edit.conditions': 'Conditions',
  'sla.edit.conditionsHint': 'Laissez un groupe décoché pour correspondre à toutes les valeurs',
  'sla.edit.matchMode': 'Mode de correspondance :',
  'sla.edit.matchAll': 'Correspondre à TOUTES les conditions',
  'sla.edit.matchAny': 'Correspondre à N’IMPORTE QUELLE condition',
  'sla.edit.groups': 'Groupes',
  'sla.edit.companies': 'Entreprises',
  'sla.edit.sources': 'Sources',
  'sla.edit.ticketTypes': 'Types de ticket',
  'sla.bh.subtitle': 'Définissez le planning hebdomadaire et le calendrier des jours fériés que les politiques SLA utilisent pour calculer les échéances.',
  'sla.bh.newCalendar': 'Nouveau calendrier',
  'sla.bh.emptyTitle': 'Créez votre premier calendrier d’heures ouvrées',
  'sla.bh.emptyDescription': 'Utilisez Nouveau calendrier pour définir le planning hebdomadaire sur lequel les politiques SLA s’appuient.',
  'sla.bh.accountDefault': 'Par défaut du compte',
  'sla.bh.closedEveryDay': 'Fermé tous les jours',
  'sla.bh.openEveryDay': 'Ouvert tous les jours',
  'sla.bh.openDaysOne': 'Ouvert 1 jour/semaine',
  'sla.bh.openDaysMany': 'Ouvert {count} jours/semaine',
  'sla.bh.holidayOne': '1 jour férié',
  'sla.bh.holidayMany': '{count} jours fériés',
  'sla.bh.deleteTitle': 'Supprimer « {name} » ?',
  'sla.bh.deleteDescription': 'Les politiques SLA et les groupes utilisant ce planning reviendront à la valeur par défaut du compte.',
  'sla.bh.deleteConfirm': 'Supprimer le planning',
  'sla.bh.newTitle': 'Nouveau calendrier d’heures ouvrées',
  'sla.bh.editTitle': 'Modifier les heures ouvrées',
  'sla.bh.saved': 'Heures ouvrées enregistrées.',
  'sla.bh.timezone': 'Fuseau horaire',
  'sla.bh.defaultCalendar': 'Calendrier par défaut',
  'sla.bh.useAsDefault': 'Utiliser pour les politiques SLA et les groupes qui ne spécifient pas leur propre calendrier',
  'sla.bh.weeklySchedule': 'Planning hebdomadaire',
  'sla.bh.colDay': 'Jour',
  'sla.bh.colOpen': 'Ouvert',
  'sla.bh.colStart': 'Début',
  'sla.bh.colEnd': 'Fin',
  'sla.bh.dayOpenAria': '{day} ouvert',
  'sla.bh.dayStartAria': 'Heure de début {day}',
  'sla.bh.dayEndAria': 'Heure de fin {day}',
  'sla.bh.holidayCalendar': 'Calendrier des jours fériés',
  'sla.bh.saveFirst': 'Enregistrez d’abord ce calendrier, puis ajoutez des jours fériés.',
  'sla.bh.holidayName': 'Nom du jour férié',
  'sla.bh.date': 'Date',
  'sla.bh.addHoliday': 'Ajouter un jour férié',
  'sla.bh.noHolidays': 'Aucun jour férié pour le moment',
  'sla.bh.noHolidaysHint': 'Ajoutez ci-dessus un jour férié daté pour l’exclure des calculs SLA.',
  'sla.bh.remove': 'Retirer',
  'sla.day.monday': 'Lundi',
  'sla.day.tuesday': 'Mardi',
  'sla.day.wednesday': 'Mercredi',
  'sla.day.thursday': 'Jeudi',
  'sla.day.friday': 'Vendredi',
  'sla.day.saturday': 'Samedi',
  'sla.day.sunday': 'Dimanche',

  'set.ftype.single_line_text': 'Texte sur une ligne',
  'set.ftype.multi_line_text': 'Texte multiligne',
  'set.ftype.dropdown': 'Liste déroulante',
  'set.ftype.checkbox': 'Case à cocher',
  'set.ftype.radio': 'Bouton radio',
  'set.ftype.multiselect': 'Sélection multiple',
  'set.ftype.lookup': 'Relation de recherche',
  'set.ftype.dependent': 'Champ dépendant',
  'set.ftype.date': 'Date',
  'set.ftype.number': 'Nombre',
  'set.ftype.decimal': 'Décimal',
  'set.ftype.desc.lookup': 'Sélectionnez un enregistrement dans une source système.',
  'set.ftype.desc.single_line_text': 'Valeur de texte courte.',
  'set.ftype.desc.multi_line_text': 'Valeur de texte long.',
  'set.ftype.desc.checkbox': 'Valeur vrai ou faux.',
  'set.ftype.desc.dropdown': 'Sélectionnez une option normalisée.',
  'set.ftype.desc.dependent': 'Les options dépendent d’un champ parent.',
  'set.ftype.desc.date': 'Valeur de date du calendrier.',
  'set.ftype.desc.number': 'Valeur entière.',
  'set.ftype.desc.decimal': 'Valeur décimale.',
  'set.src.STATIC': 'Options statiques',
  'set.src.AGENTS': 'Agents',
  'set.src.USERS': 'Utilisateurs / Clients',
  'set.src.GROUPS': 'Groupes',
  'set.src.ROLE': 'Rôles',
  'set.src.COUNTRIES': 'Pays',
  'set.src.CUSTOM': 'Liste déroulante personnalisée',
  'set.settings': 'Paramètres',
  'set.ticketFields': 'Champs du ticket',
  'set.ticketForms': 'Formulaires de ticket',
  'set.requestFailed': 'La requête a échoué. Veuillez réessayer.',
  'set.refresh': 'Actualiser',
  'set.saving': 'Enregistrement…',
  'set.saveChanges': 'Enregistrer les modifications',
  'set.default': 'Par défaut',
  'set.published': 'Publié',
  'set.draft': 'Brouillon',
  'set.publish': 'Publier',
  'set.unpublish': 'Dépublier',
  'set.deleteForm': 'Supprimer le formulaire',
  'set.description': 'Description',
  'set.relationshipSource': 'Source de la relation',
  'set.dependsOn': 'Dépend de {field}',
  'set.deleteFormTitle': 'Supprimer « {name} » ?',
  'set.deleteFormDescription': 'Ce formulaire de ticket et sa configuration seront supprimés définitivement.',
  'set.formIdRequired': 'Un identifiant de formulaire est requis.',
  'set.formNotFound': 'Formulaire de ticket introuvable.',
  'set.tf.removeOption': 'Retirer {label}',
  'set.tf.noOptions': 'Aucune option définie pour le moment.',
  'set.tf.addOptionPlaceholder': 'Ajouter une option...',
  'set.tf.add': 'Ajouter',
  'set.tf.dependsOnField': 'Dépend du champ',
  'set.tf.selectParent': '— Sélectionner le champ parent —',
  'set.tf.parentHelp': 'Le champ de liste déroulante parent dont la valeur sélectionnée détermine les options disponibles de ce champ.',
  'set.tf.optionMappings': 'Correspondances des options',
  'set.tf.savingParen': '(enregistrement...)',
  'set.tf.mappingsError': 'Impossible de charger les correspondances',
  'set.tf.archivedParen': ' (archivé)',
  'set.tf.mappedCount': '{count} associé(s)',
  'set.tf.saveFirst': 'Enregistrez d’abord le champ pour configurer les correspondances des options.',
  'set.tf.newField': 'Nouveau {type}',
  'set.tf.pageDescription': 'Gérez les définitions de champs importées, la visibilité, les règles d’obligation et l’ordre utilisé par les formulaires de ticket.',
  'set.tf.addField': 'Ajouter un champ',
  'set.tf.addFieldHelp': 'Faites glisser un type dans la liste des champs ou utilisez Ajouter.',
  'set.tf.addType': 'Ajouter {type}',
  'set.tf.registry': 'Registre des champs',
  'set.tf.savingOrder': 'Enregistrement de l’ordre…',
  'set.tf.searchAria': 'Rechercher des champs de ticket',
  'set.tf.searchPlaceholder': 'Rechercher par nom ou clé...',
  'set.tf.filterAria': 'Filtrer par type de champ',
  'set.tf.allTypes': 'Tous les types de champ',
  'set.tf.emptyFirstTitle': 'Ajoutez votre premier champ de ticket',
  'set.tf.emptyFirstDesc': 'Faites glisser un type de champ depuis la palette ou utilisez Ajouter pour en créer un.',
  'set.tf.emptyFilterTitle': 'Aucun champ ne correspond à ces filtres',
  'set.tf.emptyFilterDesc': 'Essayez un autre terme de recherche ou élargissez le filtre de type de champ.',
  'set.tf.archived': 'Archivé',
  'set.tf.dependent': 'Dépendant',
  'set.tf.customerVisible': 'Visible par le client',
  'set.tf.internal': 'Interne',
  'set.tf.configuration': 'Configuration du champ',
  'set.tf.selectTitle': 'Sélectionnez un champ à configurer',
  'set.tf.selectDesc': 'Choisissez un champ dans le registre pour modifier ses libellés, ses règles et sa visibilité.',
  'set.tf.externalId': 'ID externe : {value}',
  'set.tf.sourceRenderer': 'Source : {source} · Rendu : {renderer}',
  'set.tf.optionSource': 'Source des options : {value}',
  'set.tf.dependsOnKey': 'Dépend de : {value}',
  'set.tf.internalLabel': 'Libellé interne',
  'set.tf.customerLabel': 'Libellé client',
  'set.tf.relationshipHelp': 'Détermine d’où les valeurs de recherche sont récupérées à l’exécution.',
  'set.tf.validationVisibility': 'Validation et visibilité',
  'set.tf.requiredAgents': 'Obligatoire pour les agents',
  'set.tf.requiredCustomers': 'Obligatoire pour les clients',
  'set.tf.requiredClosure': 'Obligatoire pour la clôture',
  'set.tf.displayedCustomers': 'Affiché aux clients',
  'set.tf.customersEdit': 'Les clients peuvent modifier',
  'set.tf.customersFilter': 'Les clients peuvent filtrer',
  'set.tf.active': 'Actif',
  'set.tf.dropdownOptions': 'Options de la liste déroulante ({count})',
  'set.tf.archiveTitle': 'Archiver « {name} » ?',
  'set.tf.archiveDesc': 'Le champ deviendra inactif et indisponible pour les nouveaux tickets. Les données des tickets existants sont conservées.',
  'set.tf.archiveField': 'Archiver le champ',
  'set.tf.alreadyArchived': 'Déjà archivé',
  'set.tf.archivedNote': 'Les champs archivés restent disponibles pour les valeurs historiques.',
  'set.tfm.systemUser': 'Système',
  'set.tfm.untitled': 'Formulaire sans titre',
  'set.tfm.pageDescription': 'Créez des formulaires réutilisables et choisissez les champs importés que les agents et les clients peuvent utiliser.',
  'set.tfm.newForm': 'Nouveau formulaire',
  'set.tfm.creating': 'Création…',
  'set.tfm.allForms': 'Tous les formulaires',
  'set.tfm.configuredOne': '{count} formulaire configuré',
  'set.tfm.configuredMany': '{count} formulaires configurés',
  'set.tfm.filter': 'Filtre',
  'set.tfm.searchAria': 'Rechercher des formulaires de ticket',
  'set.tfm.searchPlaceholder': 'Rechercher des formulaires…',
  'set.tfm.status': 'Statut',
  'set.tfm.allStatuses': 'Tous les statuts',
  'set.tfm.emptyFilterTitle': 'Aucun formulaire ne correspond à ces filtres',
  'set.tfm.emptyFilterDesc': 'Essayez un autre terme de recherche ou élargissez le filtre de statut.',
  'set.tfm.emptyFirstTitle': 'Créez votre premier formulaire de ticket',
  'set.tfm.emptyFirstDesc': 'Créez un formulaire pour commencer à configurer les champs importés.',
  'set.tfm.createFirst': 'Créez votre premier formulaire',
  'set.tfm.colName': 'Nom',
  'set.tfm.colCreatedAt': 'Créé le',
  'set.tfm.colUpdatedBy': 'Dernière mise à jour par',
  'set.tfm.colUpdatedAt': 'Dernière mise à jour le',
  'set.tfm.colPortals': 'Portails associés',
  'set.tfm.colActions': 'Actions',
  'set.tfm.notConfigured': 'Non configuré',
  'set.tfm.actionsFor': 'Actions pour {name}',
  'set.tfm.editForm': 'Modifier le formulaire',
  'set.tb.section.default.title': 'Champs par défaut',
  'set.tb.section.default.desc': 'Champs essentiels du workflow de support importés du système source.',
  'set.tb.section.custom.title': 'Champs personnalisés',
  'set.tb.section.custom.desc': 'Champs supplémentaires configurés pour votre processus de support.',
  'set.tb.section.nested.title': 'Champs imbriqués',
  'set.tb.section.nested.desc': 'Champs dépendants dont les options suivent un champ parent.',
  'set.tb.discardTitle': 'Abandonner les modifications non enregistrées ?',
  'set.tb.discardDesc': 'Vos modifications de ce formulaire de ticket n’ont pas été enregistrées.',
  'set.tb.leave': 'Quitter sans enregistrer',
  'set.tb.nameRequired': 'Le nom du formulaire est requis.',
  'set.tb.saved': 'Formulaire enregistré.',
  'set.tb.nowPublished': 'Formulaire publié.',
  'set.tb.nowUnpublished': 'Formulaire dépublié.',
  'set.tb.admin': 'Admin',
  'set.tb.builder': 'Éditeur',
  'set.tb.titleAria': 'Titre du formulaire',
  'set.tb.defaultLocked': 'Par défaut / verrouillé',
  'set.tb.previewPortal': 'Prévisualiser sur le portail',
  'set.tb.configureTitle': 'Configurez les champs inclus dans ce formulaire.',
  'set.tb.configureDesc': 'Les modifications sont enregistrées dans la base de données du centre de support lorsque vous sélectionnez Enregistrer les modifications. Les champs obligatoires restent activés.',
  'set.tb.formDetails': 'Détails du formulaire',
  'set.tb.formDetailsHelp': 'Utilisez une description claire pour que les administrateurs sachent quand utiliser ce formulaire.',
  'set.tb.descPlaceholder': 'Décrivez quand ce formulaire doit être utilisé…',
  'set.tb.importedFields': 'Champs importés',
  'set.tb.importedHelp': 'Faites glisser pour réorganiser les champs. Utilisez le commutateur pour inclure ou exclure un champ de ce formulaire.',
  'set.tb.noneInSection': 'Aucun champ importé dans cette section.',
  'set.tb.dragReorder': 'Faire glisser pour réorganiser',
  'set.tb.required': 'Obligatoire',
  'set.tb.nested': 'Imbriqué',
  'set.tb.enableField': 'Activer {label}',
  'set.tb.enabled': 'Activé',
  'set.tb.disabled': 'Désactivé',
  'set.tb.emptyTitle': 'Aucun champ à configurer pour le moment',
  'set.tb.emptyDesc': 'Importez des champs de ticket pour commencer à construire ce formulaire.',
  'set.tb.deleting': 'Suppression…',
  'set.tp.loadError': 'Impossible de charger l’aperçu du formulaire.',
  'set.tp.preview': 'Aperçu',
  'set.tp.customerPreview': 'Aperçu côté client',
  'set.tp.backToBuilder': 'Retour à l’éditeur',
  'set.tp.modeTitle': 'Mode aperçu',
  'set.tp.modeDesc': 'Il s’agit d’un aperçu sans envoi. Tous les champs activés sont affichés dans l’ordre enregistré du formulaire.',
  'set.tp.emptyTitle': 'Aucun champ n’est encore activé',
  'set.tp.emptyDesc': 'Activez des champs dans l’éditeur de formulaire pour les voir dans cet aperçu.',

  'por.error.generic': 'Impossible de terminer la requête.',
  'por.error.requestNotFound': 'Demande introuvable.',
  'por.error.formUnavailable': 'Le formulaire de demande n’est pas disponible.',
  'por.error.articleNotFound': 'Article introuvable.',
  'por.error.selectRating': 'Veuillez sélectionner une note de 1 à 5.',
  'por.tab.all': 'Toutes',
  'por.list.title': 'Mes demandes de support',
  'por.list.description': 'Suivez vos demandes et répondez à l’équipe de support.',
  'por.list.newRequest': 'Nouvelle demande',
  'por.list.knowledgeBase': 'Base de connaissances',
  'por.list.filterByStatus': 'Filtrer les demandes par statut',
  'por.list.searchPlaceholder': 'Rechercher par objet…',
  'por.list.count': '{count} demandes',
  'por.list.countOne': '{count} demande',
  'por.list.emptyFilteredTitle': 'Aucune demande ne correspond à cette vue',
  'por.list.emptyTitle': 'Aucune demande pour le moment',
  'por.list.emptyFilteredDescription': 'Essayez l’onglet Toutes ou un autre terme de recherche.',
  'por.list.emptyDescription': 'Envoyez une demande et l’équipe de support la prendra en charge.',
  'por.list.submitFirst': 'Envoyez votre première demande',
  'por.col.request': 'Demande',
  'por.col.subject': 'Objet',
  'por.col.status': 'Statut',
  'por.col.priority': 'Priorité',
  'por.col.created': 'Créée',
  'por.detail.myRequests': 'Mes demandes',
  'por.detail.reopen': 'Rouvrir cette demande',
  'por.detail.attachments': 'Pièces jointes',
  'por.detail.download': 'Télécharger',
  'por.detail.conversation': 'Conversation',
  'por.detail.noReplies': 'Aucune réponse pour le moment',
  'por.detail.noRepliesHint': 'Ajoutez une réponse ci-dessous et l’équipe de support la prendra en charge.',
  'por.detail.reply': 'Répondre',
  'por.detail.replyPlaceholder': 'Écrire une réponse',
  'por.detail.sending': 'Envoi…',
  'por.detail.sendReply': 'Envoyer la réponse',
  'por.file.sizeKb': '{size} Ko',
  'por.file.remove': 'Retirer {name}',
  'por.submit.newRequest': 'Nouvelle demande',
  'por.submit.defaultTitle': 'Envoyer une demande de support',
  'por.submit.intro': 'Remplissez les champs ci-dessous et envoyez votre demande.',
  'por.submit.subjectRequired': 'L’objet est requis',
  'por.submit.descriptionRequired': 'La description est requise',
  'por.submit.attachments': 'Pièces jointes',
  'por.submit.submitting': 'Envoi…',
  'por.submit.submit': 'Envoyer la demande',
  'por.kb.portal': 'Portail',
  'por.kb.title': 'Base de connaissances',
  'por.kb.description': 'Trouvez des réponses avant d’envoyer une demande.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Résultats de recherche',
  'por.kb.searchPlaceholder': 'Rechercher des articles',
  'por.kb.emptyTitle': 'Aucun article publié pour le moment',
  'por.kb.emptyDescription': 'Envoyez une demande et l’équipe de support vous aidera directement.',
  'por.kb.noFolders': 'Aucun dossier',
  'por.kb.articles': '{count} articles',
  'por.kb.articlesOne': '{count} article',
  'por.kb.noMatch': 'Aucun article ne correspond à « {query} »',
  'por.kb.folderEmpty': 'Aucun article dans ce dossier pour le moment',
  'por.kb.noMatchHint': 'Essayez un terme de recherche plus court ou envoyez plutôt une demande.',
  'por.kb.folderEmptyHint': 'Parcourez un autre dossier ou envoyez plutôt une demande.',
  'por.kb.submitRequest': 'Envoyer une demande',
  'por.kb.views': '{count} vues',
  'por.kb.thanks': 'Merci pour votre retour !',
  'por.kb.helpful': 'Cet article vous a-t-il été utile ?',
  'por.kb.yes': 'Oui',
  'por.kb.no': 'Non',
  'por.csat.thanksTitle': 'Merci pour votre retour',
  'por.csat.thanksBody': 'Votre réponse a été enregistrée.',
  'por.csat.title': 'Comment avons-nous fait ?',
  'por.csat.request': 'Demande n° {number} : {subject}',
  'por.csat.rating': 'Note',
  'por.csat.stars': '{count} étoiles',
  'por.csat.comment': 'Commentaire',
  'por.csat.submit': 'Envoyer le retour',
  'agents.tempPassword.title': 'Mot de passe temporaire',
  'agents.tempPassword.help': 'Définissez un mot de passe temporaire pour cet agent. Il devra en choisir un nouveau à sa prochaine connexion. 12 caractères minimum.',
  'agents.tempPassword.button': 'Définir le mot de passe temporaire',
  'agents.tempPassword.saving': 'Définition en cours…',
  'agents.tempPassword.error': 'Impossible de définir le mot de passe temporaire.',
  'ui.showPassword': 'Afficher le mot de passe',
  'ui.hidePassword': 'Masquer le mot de passe',
  'dashboard.awaitingResolutionConfirmation': 'En attente de confirmation de résolution',
  'dashboard.awaitingUserReply': 'En attente de réponse de l’utilisateur',
  'dashboard.changeRequests': 'Demandes de changement',
  'agents.tempPassword.successEmailed': 'Mot de passe temporaire défini et envoyé par e-mail à l’agent.',
  'agents.tempPassword.successNotEmailed': 'Mot de passe temporaire défini, mais l’e-mail n’a pas pu être envoyé. Communiquez le mot de passe à l’agent par un canal sécurisé.',
} as const;

export default fr;
